import api from '@/api';
import Vue from "vue";
import { Message } from 'element-ui'
import redmine from './redmine'
import stt from './stt'
import store_sv from './store_sv';
import moment from 'moment';
var sd = require("silly-datetime");
const _ = require('lodash');
import momentTimezone from 'moment-timezone'
import { omit } from 'lodash';
import utils from '../../utils/index.js'
import vueUtils from '../../utils/utils.js';

const questioner_logo = require('@/assets/img/user_logo.png');
const operator_logo = require('@/assets/img/operator.png');
const watson_logo = require('@/assets/img/moppy1.png')
const voicebot_logo = require("@/assets/img/AIvoicebot.png");
const state = {
  innerChatUserList: [],
  toUpdateUserNameForRedmineHisFlg: false, // ユーザー取得したら、Redmineの[all text]のユーザー名称を更新するために
  issue_waitedTime: "", // 応対待ち時間
  userInfoForUnsolvedIssues: {phoneNum:"", logoUrl:""}, // ユーザー情報（未解決チケット検索する時利用）
  unsolvedIssueList: [], // 未解決チケット
  searchDetail_unsolvedIssueListVisible: false, // 未解決チケット検索中flg
  searchDetail_issue_tracker: "", // 直前の応対のtracker
  searchDetail_issue_category: "", // チケットのカテゴリー
  searchDetail_issue_system_logo:"",
  searchDetail_issue_system_name:"",
  searchDetail_issue_system_num:"",
  searchDetail_issue_channel:"",
  noiseCancelBk: 0,
  noiseCancelSpeech: 0,
  showImmediately: true,
  query_note: '',
  systemSingleMode: '',
  personalSingleMode: '',
  personalEnable: 0,
  navigationText: '',
  ngWordColor: false,
  wowWordColor: false,
  currentKeyword: '',
  keywordRate: 90,
  user_name: '',
  user_id: '',
  tel_num: '',
  user_role: '',
  status: 'AVAILABLED',
  // op_answered: false,
  is_away: false,
  html_const: {},
  emotionText: 'センチメント分析',
  nexmo_websocket_uri: '',
  // sip config
  sip_domain:'',
  sip_wss_server:'',
  sip_pw:'',
  sip_websocket_port:'',
  sip_server_path:'',
  questioner_logo: questioner_logo,
  operator_logo: operator_logo,
  operator_logo_f2f:operator_logo,
  watson_logo: watson_logo,
  // currentWowWord:'',
  temp_VoiceConnectionMode: '',
  temp_VoiceConvertMode: '',

  modeFlag: true,
  talkStatus: '',
  phonenum: '',
  ws_mode: '',
  turnMicStart_title: '',
  ws_start_button: 'info',
  currentCustomerPhoneNum: '',

  sttConfig: {
  },

  chatSttConfig: {

  },
  //mobile flagv-cloak
  draggableFlag: true,

  //pi
  customer_name: "",
  facet_title: "",
  facet_value: "",
  facet_value0: "",
  facet_message: "",
  advice_info: "",
  credibility_message: "",
  pimessageVisible: false,
  noContentsMessage: "",
  pi_loading: true,

  piEmptyFlg:true,
  piCustomerInfoEmptyFlg:true,
  piIssueListEmptyFlg:true,
  // sttMode:''
  piDiaLogVisible: false,
  //chat pi
  chatPiDiaLogVisible: false,

  //piIssue
  piIssuesVisible: true,

  //piCustomr
  piCustomerVisible: true,
  //pichatbot
  piChatbotVisible:true,
  //pi call info
  piCallWaitVisible: true,
  disabledCallButton:true,
  piRecordVisible: true,
  PiIssueList: [],
  showPiButton: "no",
  showChatPiButton: "no",

  //picallinfo
  piCallInfoObj: {
    pi_calling_count: 0,
    pi_waiting_count: 0,
    pi_calling: [],
    pi_waiting: []
  },
  piCallInfoObj_ws:{
    pi_calling_count: 0,
    pi_waiting_count: 0,
    pi_calling: [],
    pi_waiting: []
  },
  facetFlg:false,
  ngCount: "",
  categoryList: [],
  longTimeCount: "",
  customerInfo: [],
  customerInfo2: [],
  customerInfo3:[],
  customerInfo_summary: [],

  // 所有顾客，取自customer_info表
  customerList: [],
  // 所有用户，取自user_info表
  userList: [],
  piRecordInfoObj: {
    pi_record_count: 0,
    piRecordInfo: []
  },

  // manual chat button status
  manualButtonStatus: "manualStart",
  manualButtonDisabled:true,

  // manual chat issue dialog
  manualChatIssueDialogVisible: false,

  // manual chat
  // presence info
  presenceInfoObj: {
    chating: [],
    waiting: [],
    ending: [],
    chating_count: "",
    waiting_count: "",
    ending_count: "",
  },

  manualChatSendMessageFlg:true,
  waitCloseIssueId:[],
  manualChatStartButtonList: [],
  manualChatButtonStatus: "",
  holdOnUserList:[],
  // holdOnStatus:false,
  showHoldOnButton:true,

  manualChatMessageList: [],

  writingFlg: "",
  manualChatStartTime: "",
  messageId: 0,


  manualChatQuestionerId: "",
  manualChatCreateIssueUserId:"",
  manualChatShowWaitingListFlg:true,
  manualChatQuestionerName: "",

  manualChatModeIssueId: "",
  manualChatbotIssueId:"",
  manualChatbotCategoryTag:"",
  manualChatbotCommentText:"",
  manualChatbotAllTextList:[],
  manualChatbotShowFlg:true,
  manualChatButtonType: "primary",

  manualMessageStatus: "",
  autocompleteData: "",
  currentUserCount:5,

  manualChatUser: [],

  uc1AllTextList: [],
  uc1IssueId: [],
  chatBotUserIdList: [],

  // manual chat user count
  manualChatUserList: [],//
  manualChatUserCount: 0,
  piIssueStatusFlg:false,
  newUsernotificationFlg: "no",
  // user_id:null,

  uc1Finishflg: false,
  manualChatStartTimeList: [],
  manualChatPiStatusList:[
    {
      value: "Online",
      label: "待機中",
    },
    {
      value: "OnThePhone",
      label: "応対中",
      disabled: true,
    },
    {
      value: "Busy",
      label: "作業中",
    },
    {
      value: "Away",
      label: "応対不可",
    },
    {
      value: "Offline",
      label: "応対不可",
    },
  ],
  manualChatPiStatus:"Online",
  manualChatPiStatusText:"待機中",

  piRefresh:true,
  login_id:"",
  empathyMatChingToken:"",
  similarity:"",
  isBlingFlg:false,
  isBlingFlg_call:false,
  phone_questioner_name:"",
  phone_questioner_logo:"",
  pi_phone_questioner_logo:"",
  call_error_finished:false,
  heart_change_distance:"",
  heart_change_distance_big:"",
  pi_chat_questioner_logo:"",

  mqseqList: [],
  chat_current_status:"",

  empathyList:[],
  chat_ChatingSortByTimeFlg:false,
  chat_WaitingSortByTimeFlg:false,
  chat_EndingSortByTimeFlg:false,

  phone_ChatingSortByTimeFlg:false,
  phone_WaitingSortByTimeFlg:true, // default sort waitingtime
  phone_EndingSortByTimeFlg:false,

  dropdownSortTitle:"先着順",
  issue_Status:"1",
  dropdownText:"ON GOING",

  isShowSearchCondition:false,
  isShowSearchConsequence:false,
  searchConditionForm:{
    id:'',
    name:'',
    phone_number:'',
    email:'',
    birthday:'',
    address:''
  },
  currentPhoneUserInfo:{
    phone_number:'',
  },
  searchDetailUserInfo:{

  },
  searchDetailTitle:{
    id:"",
    name:""
  },
  searchDetailUserLogo:"",
  searchDetail_pimessageVisible:false,

 searchDetail_customer_name:"",

searchDetail_facet_title:"",
 searchDetail_facet_value:"",
 searchDetail_facet_value0:"",
 searchDetail_facet_message:"",
 searchDetail_advice_info:"",
 searchDetail_credibility_message:"",
 searchDetail_pi_loading:true,
 searchDetail_facetFlg:false,
 searchDetail_piEmptyFlg:true,

searchDetail_PiIssueList:[],
searchDetail_ngCount:"",
searchDetail_longTimeCount:"",
 searchDetail_categoryList:[],
 searchDetail_piIssueStatusFlg:false,
 searchDetail_piIssueListEmptyFlg:true,
searchDetail_piIssuesVisible:true,

 searchDetail_customerInfo:[],
 searchDetail_customerInfo2:[],
searchDetail_customerInfo3:[],
 searchDetail_piCustomerVisible:true,
 searchDetail_piCustomerInfoEmptyFlg:true,

searchDetail_heart_change_distance:"",
searchDetail_heart_change_distance_big:"",
searchDetail_similarity:"",
isSearchLoading:false,


newUserInfoForm:{
phone_number:'',
firstname:'',
lastname:'',
mail:'',
sex:'',
birthday:'',
former_address:'',
current_address:'',
customer_name_yomi:''
},

newUserGenderOptions:[
  {
    value: '1',
    label: '男性'
  }, {
    value: '0',
    label: '女性'
  },
],




  searchDetailDialogVisible:false,
  addNewUserDialogVisible:false,

  searchConsequence:[],
  // temp_chat_waiting_questioner:"",
  temp_selected_logo_cti:'',
  role: "",
}

var statusWs = null;
var statusWsUrl = null;
var statusLockReconnect = false;
// pi
var piWs = null;
var piWsUrl = null;
var piStatusLockReconnect = false;
//chat pi
var chatPiWs = null;
var chatPiWsUrl = null;
var chatPiStatusLockReconnect = false;

//chat pi message
var chatPiMessageWs = null;
var chatPiMessageWsUrl = null;
var ChatPiMessageStatusLockReconnect = false;

//F2F sv web socket
var F2FSvWs = null;
var F2FSvWsUrl = null;
var F2FSvStatusLockReconnect = null


var piMessageFlag = true;



// const nexmo_websocket_uri = 'ws://aicc-nexmo-websocket-pbx.mybluemix.net/';

// stt管理画面の随時変換モード
const mode = {
  asterisk: 'NEXMO_ASTERISK_PBX_MODE',
  otherPbx: 'NEXMO_OTHER_PBX_MODE',
  converger: 'CONVERGER_MODE',
  standMic: 'STAND_MIC_MODE',
  manualChat: 'MANUAL_CHAT_MODE'
}
const getters = {
  // 所有用户和顾客
  allUsersAndCustomers(state) {
    let arr = [];
    // 先处理userList再处理customerList，保证当user_info表和customer_info表中有相同手机号时以user_info表为准
    state.userList.forEach(user => arr.push({
      id: user.user_id,
      phone: user.tel_num,
      name: vueUtils.computeFullName(user.lastname, user.firstname),
      firstname: user.firstname,
      lastname: user.lastname,
      logo: user.logo_url,
    }))
    state.customerList.forEach(customer => arr.push({
      id: customer.customer_id,
      phone: customer.phonenum,
      name: vueUtils.computeFullName(customer.lastname, customer.firstname),
      firstname: customer.firstname,
      lastname: customer.lastname,
      logo: customer.logo_url,
    }))
    return arr;
  }
}
const actions = {
  // fetchLogos(context, item) {
  //   api.getLogos().then((res) => {
  //     context.commit('changeLogos', res.data.data);
  //   }, (err) => {
  //     console.log('changeLogos', err);
  //   });
  // },

  getAllInnerChatUserList(){
    api.getAllInnerChatUserList().then((res)=>{
      if(res.data.data){
        state.innerChatUserList = res.data.data;
      }
    })
  },

  getEmpathyMatchingToken(context, item){

    api.getEmpathyMatchingToken().then((res)=>{
      if(res.data.data){
        state.empathyMatChingToken = res.data.data;
      }
      console.log("empathyMatChingToken",state.empathyMatChingToken);
    })
  },

  //get pi call info
  getPiCallInfo(context, item) {
    // state.tel_num, state.ws_mode, currentTime
    let myDate = new Date();
    let date = moment(myDate).format("YYYYMMDD");
    let currentTime = date;
    let params = {
      sipNum: state.tel_num,
      modeName: state.ws_mode,
      currentTime: currentTime
    }
    // console.log("params", params)
    //getPiCallInfo()
    api.getPiCallInfo(params).then((res) => {
      console.log("res", res)
      state.piCallInfoObj.pi_calling = res.data.result.calling;
      if(state.piCallInfoObj.pi_calling.length >0){
        state.isBlingFlg_call = false;

        context.commit(
          "changeNavigationText",
          ""
        );
      }
      let presence_message = {
        "ivrGuide": "IVR案内中",
        "isWaiting": "待ち呼",
        "isAbandoned": "閾値超え待ち呼",
        "answered": "担当中"
      }
      let calling_count = 0
      for (let i of state.piCallInfoObj.pi_calling) {
//empathy
        i['current_calling']= false;
        i["heart_change_distance"] = null;
        i["similarity"] = null;



        calling_count++;
        // IVR UPDATE
        // let temp = _.find(state.customerList, function (o) { return o.phonenum == i.telNum });
        // if (temp) {

        //   if(temp.lastname && temp.firstname){
        //     i.customerName = temp.lastname+temp.firstname;
        //     state.phone_questioner_name = temp.lastname+temp.firstname;
        //   }else{


        //     i.customerName = 'ゲスト';
        //     state.phone_questioner_name = 'ゲスト';
        //   }

        //   // state.phone_questioner_name = temp.lastname+temp.firstname;
        //   if(temp.logo_url){
        //     state.phone_questioner_logo = temp.logo_url;
        //     i.logo_url = temp.logo_url;
        //   }else{
        //     state.phone_questioner_logo = questioner_logo;
        //     i.logo_url = questioner_logo;
        //   }


        // }else{
        //   let temp_ws = _.find(state.piCallInfoObj_ws.pi_calling,function(o){return o.telNum = i.telNum});
        //   if(temp_ws){

        //     if(temp_ws.guestDumyLastName && temp_ws.guestDumyFirstName){
        //       i.customerName = temp_ws.guestDumyLastName+ temp_ws.guestDumyFirstName;
        //       state.phone_questioner_name = temp_ws.guestDumyLastName+ temp_ws.guestDumyFirstName;
        //     }else{
        //       i.customerName = 'ゲスト';
        //     state.phone_questioner_name = 'ゲスト';
        //     }

        //   }else{
        //     i.customerName = 'ゲスト';
        //     state.phone_questioner_name = 'ゲスト';
        //   }
        //   state.phone_questioner_logo = questioner_logo;
        //   i.logo_url = questioner_logo;
        //   // i.customerName = 'ゲスト';
        //   // state.phone_questioner_name = 'ゲスト';
        // }
        // i.timer = setInterval(function(){},1000);
        // i.timeDiff = null;
        i.timeDiff = getTimeDiff(i.startTime)
        for (let j of Object.keys(presence_message)) {
          if (i.presence == j) {
            i.presence = presence_message[j];
          }
        }
      }

      //empathy
      for(let i of state.piCallInfoObj.pi_calling){
        i.current = false;
        let temp_params = {
          user_phoneNum:i.telNum,
          // user_phoneNum:'01006',
          login_email:state.login_id,
          token:state.empathyMatChingToken,
          modeName: state.ws_mode,
          chatStatus:"",
        }
        let temp_heart_change_distance = null;
        let temp_similarity = null;
        try{
          api.getEmpathyMatchingInfo(temp_params).then((res)=>{
              if(res.data != "fail" && res.data.data.empathy50){
                if(res.data.data.empathy50<0.3){
                  let temp_similarity = 0.3*(0.7+res.data.data.empathy50);
                  temp_heart_change_distance = (1- temp_similarity)*50;
                }else{
                  temp_heart_change_distance = (1- res.data.data.empathy50)*50;
                }
                temp_similarity = toPercent(res.data.data.empathy50) + "%";
                i.heart_change_distance = temp_heart_change_distance;
                i.similarity = temp_similarity;
                // state.piCallInfoObj.pi_calling.sort();

                if(state.phone_ChatingSortByTimeFlg){
                  // state.piCallInfoObj.pi_calling =   _.orderBy(state.piCallInfoObj.pi_calling,['startTime'],['desc']);
                  state.piCallInfoObj.pi_calling = _.sortBy(state.piCallInfoObj.pi_calling, function(o) { return o.startTime; }).reverse();
                }else{
                  // state.piCallInfoObj.pi_calling =   _.orderBy(state.piCallInfoObj.pi_calling,['similarity'],['desc']);
                  state.piCallInfoObj.pi_calling = _.sortBy(state.piCallInfoObj.pi_calling, function(o) { return o.startTime; }).reverse();
                }
                console.log("empathyinfo--->",res)
              }else{
                temp_similarity = '--%';
                i.heart_change_distance = temp_heart_change_distance;
                i.similarity = temp_similarity;
                // state.piCallInfoObj.pi_calling.sort();
                if(state.phone_ChatingSortByTimeFlg){
                  // state.piCallInfoObj.pi_calling =   _.orderBy(state.piCallInfoObj.pi_calling,['startTime'],['desc']);
                  state.piCallInfoObj.pi_calling = _.sortBy(state.piCallInfoObj.pi_calling, function(o) { return o.startTime; }).reverse();
                }else{
                  // state.piCallInfoObj.pi_calling =   _.orderBy(state.piCallInfoObj.pi_calling,['similarity'],['desc']);
                  state.piCallInfoObj.pi_calling = _.sortBy(state.piCallInfoObj.pi_calling, function(o) { return o.startTime; }).reverse();
                }
                console.log("fail")
              }

            }),(err)=>{
              console.log("pi error", err);
            }
          }catch(err){
            console.log(err);
          }
      }
      state.piCallInfoObj.pi_calling_count = calling_count;
      // console.log("pi_calling:", state.piCallInfoObj.pi_calling)
      state.piCallInfoObj.pi_waiting = res.data.result.waiting;

//       let params_11 = {
//         guestDumyFirstName: "ゲスト",
// guestDumyLastName: "5/20/2022, 12:15:03 PM_1",
// presence: "ivrGuide",
// startTime: "2022-05-20T12:15:04.478Z",
// telNum: "",
// // telNum: "8641188151739",
// time: ""

//       }
      // state.piCallInfoObj.pi_waiting.push(params_11)
      for(let i of state.piCallInfoObj.pi_waiting){
        i["current_waiting"] = false;
        i["heart_change_distance"] = null;
        i["similarity"] = null;
        i["current"] = false;
      }

      if(state.piCallInfoObj.pi_waiting.length>0){
        if(state.ws_mode === 'NEXMO_ASTERISK_PBX_MODE'){
          context.commit(
            "changeNavigationText",
            state.html_const.cons_264_new_call_coming //発生中の新規呼があります
          );
        }

        if(!state.piDiaLogVisible){
          state.isBlingFlg_call = true;
        }else{
          state.isBlingFlg_call = false;
        }
      }
      // console.log("pi_waiting:", state.piCallInfoObj.pi_waiting)

      // let customerName = null;
      let waiting_count = 0;
      for (let i of state.piCallInfoObj.pi_waiting) {
        waiting_count++;
        // let temp = _.find(state.customerList, function (o) { return o.phonenum == i.telNum });
        // if (temp) {
        //   if(temp.lastname && temp.firstname){
        //     i.customerName = temp.lastname+temp.firstname;
        //   }else{

        //     i.customerName = 'ゲスト';
        //   }
        //   if(temp.logo_url){
        //     i.logo_url = temp.logo_url;
        //   }else{
        //     i.logo_url = questioner_logo;
        //   }
        // }else{
        //   let temp_ws = _.find(state.piCallInfoObj_ws.pi_waiting,function(o){return o.telNum = i.telNum});
        //   if(temp_ws){
        //     if(temp_ws.guestDumyLastName && temp_ws.guestDumyFirstName){
        //       i.customerName = temp_ws.guestDumyLastName+ temp_ws.guestDumyFirstName
        //     }else{
        //       i.customerName = 'ゲスト';
        //     }

        //   }else{
        //     i.customerName = 'ゲスト';
        //   }
        //   i.logo_url = questioner_logo;
        //   // i.customerName = 'ゲスト';
        // }
        i.timeDiff = getTimeDiff(i.startTime);
        for (let j of Object.keys(presence_message)) {
          if (i.presence == j) {
            i.presence = presence_message[j];
          }
        }
      }


      for(let i of state.piCallInfoObj.pi_waiting){
        let temp_params = {
          user_phoneNum:i.telNum,
          // user_phoneNum:'01006',
          login_email:state.login_id,
          token:state.empathyMatChingToken,
          modeName: state.ws_mode,
          chatStatus:"",
        }
        let temp_heart_change_distance = null;
        let temp_similarity = null;
        try{
          api.getEmpathyMatchingInfo(temp_params).then((res)=>{
              if(res.data != "fail" && res.data.data.empathy50){
                if(res.data.data.empathy50<0.3){
                  let temp_similarity = 0.3*(0.7+res.data.data.empathy50);
                  temp_heart_change_distance = (1- temp_similarity)*50;
                }else{
                  temp_heart_change_distance = (1- res.data.data.empathy50)*50;
                }
                temp_similarity = toPercent(res.data.data.empathy50) + "%";
                i.heart_change_distance = temp_heart_change_distance;
                i.similarity = temp_similarity;
                // state.piCallInfoObj.pi_waiting.sort();
                if(state.phone_WaitingSortByTimeFlg){
                  // state.piCallInfoObj.pi_waiting =   _.orderBy(state.piCallInfoObj.pi_waiting,['startTime'],['desc']);
                  state.piCallInfoObj.pi_waiting = _.sortBy(state.piCallInfoObj.pi_waiting, function(o) { return o.startTime; }).reverse();
                }else{
                  // state.piCallInfoObj.pi_waiting =   _.orderBy(state.piCallInfoObj.pi_waiting,['similarity'],['desc']);
                  state.piCallInfoObj.pi_waiting = _.sortBy(state.piCallInfoObj.pi_waiting, function(o) { return o.startTime; }).reverse();
                }

                console.log("empathyinfo--->",res)
              }else{
                temp_similarity = '--%';
                i.heart_change_distance = temp_heart_change_distance;
                i.similarity = temp_similarity;
                // state.piCallInfoObj.pi_waiting.sort();
                if(state.phone_WaitingSortByTimeFlg){
                  // state.piCallInfoObj.pi_waiting =   _.orderBy(state.piCallInfoObj.pi_waiting,['startTime'],['desc']);
                  state.piCallInfoObj.pi_waiting = _.sortBy( state.piCallInfoObj.pi_waiting, function(o) { return o.startTime; }).reverse();
                }else{
                  // state.piCallInfoObj.pi_waiting =   _.orderBy(state.piCallInfoObj.pi_waiting,['similarity'],['desc']);
                  state.piCallInfoObj.pi_waiting = _.sortBy( state.piCallInfoObj.pi_waiting, function(o) { return o.startTime; }).reverse();
                }
                console.log("fail")
              }

            }),(err)=>{
              console.log("pi error", err);
            }
          }catch(err){
            console.log(err);
          }


      }


      function toPercent(point) {
        var str = Number(point * 100).toFixed(0)
        // str += "%";
        str = parseInt(str);
        // console.log(typeof (str))
        return str;
      }



      console.log(" state.piCallInfoObj.pi_waiting", state.piCallInfoObj.pi_waiting)

      state.piCallInfoObj.pi_waiting_count = waiting_count;
      // console.log("pi_waiting2:", state.piCallInfoObj.pi_waiting)
      // let currentTime = getCurrentTime();
      // let currentTime = '20211019';//test
      state.piCallWaitVisible = false;
      state.piRecordInfoObj.piRecordInfo = res.data.result.ending;

      //ending:

      for(let i of state.piRecordInfoObj.piRecordInfo){
        i['current_ending']= false;
        i["heart_change_distance"] = null;
        i["similarity"] = null;
        // i.call_end_time = moment().format("YYYY-MM-DD HH:mm:ss");
      }
      for(let i of state.piRecordInfoObj.piRecordInfo){
        let temp_params = {
          user_phoneNum:i.telnum,
          // user_phoneNum:'01006',
          login_email:state.login_id,
          token:state.empathyMatChingToken,
          modeName: state.ws_mode,
          chatStatus:"",
        }
        let temp_heart_change_distance = null;
        let temp_similarity = null;
        try{
          api.getEmpathyMatchingInfo(temp_params).then((res)=>{
              if(res.data != "fail" && res.data.data.empathy50){
                if(res.data.data.empathy50<0.3){
                  let temp_similarity = 0.3*(0.7+res.data.data.empathy50);
                  temp_heart_change_distance = (1- temp_similarity)*50;
                }else{
                  temp_heart_change_distance = (1- res.data.data.empathy50)*50;
                }
                temp_similarity = toPercent(res.data.data.empathy50) + "%";
                i.heart_change_distance = temp_heart_change_distance;
                i.similarity = temp_similarity;
                // state.piRecordInfoObj.piRecordInfo.sort();
                if(state.phone_EndingSortByTimeFlg){
                  state.piRecordInfoObj.piRecordInfo = _.sortBy( state.piRecordInfoObj.piRecordInfo, function(o) { return o.call_end_time; }).reverse();
                }else{
                  state.piRecordInfoObj.piRecordInfo =   _.orderBy(state.piRecordInfoObj.piRecordInfo,['similarity'],['desc']);
                }

                console.log("empathyinfo--->",res)
              }else{
                temp_similarity = '--%';
                i.heart_change_distance = temp_heart_change_distance;
                i.similarity = temp_similarity;
                // state.piRecordInfoObj.piRecordInfo.sort();
                if(state.phone_EndingSortByTimeFlg){
                  state.piRecordInfoObj.piRecordInfo = _.sortBy( state.piRecordInfoObj.piRecordInfo, function(o) { return o.call_end_time; }).reverse();
                }else{
                  state.piRecordInfoObj.piRecordInfo =   _.orderBy(state.piRecordInfoObj.piRecordInfo,['similarity'],['desc']);
                }
                console.log("fail")
              }

            }),(err)=>{
              console.log("pi error", err);
            }
          }catch(err){
            console.log(err);
          }
      }

      let Record_count = 0;
      for (let i of state.piRecordInfoObj.piRecordInfo) {
        Record_count++;
        // let temp = _.find(state.customerList, function (o) { return o.phonenum == i.telnum });//
        // if (temp) {
        //   if(temp.lastname && temp.firstname){
        //     i.customerName = temp.lastname+temp.firstname;
        //   }else{
        //     i.customerName = 'ゲスト';
        //   }
        //   if(temp.logo_url){
        //     i.logo_url = temp.logo_url;
        //   }else{
        //     i.logo_url = questioner_logo;
        //   }
        // }else{
        //   try{
        //     let params = {
        //       phonenum : i.telnum
        //     }
        //     api.getCustomerInfoByNum(params).then((res)=>{
        //       console.log(res);
        //       if(res.data != 'fail'){
        //         if(res.data.data[0]){
        //           if(res.data.data[0].firstname && res.data.data[0].lastname){
        //             i.customerName = res.data.data[0].lastname + res.data.data[0].firstname;
        //           }else{
        //             i.customerName = 'ゲスト'
        //           }
        //         }else{
        //           i.customerName = 'ゲスト'
        //         }

        //       }

        //     },(err)=>{
        //       console.log(err);
        //     })
        //   }catch(err){
        //     console.log(err);
        //   }

        //   i.logo_url = questioner_logo;
        //   // i.customerName = 'ゲスト';
        // }
        // i.timeDiff = null;
        i.timeDiff = getTimeDiff(i.call_end_time);
        // let timer = getTimeDiffTimer(timeDiff);

        // console.log("i.timeDiff",i.timeDiff)
      }
      state.piRecordInfoObj.pi_record_count = Record_count;
      state.piRecordVisible = false;




      // getUserCallRecordForPi(state.tel_num, state.ws_mode, currentTime);



      function getTimeDiff(startTime) {
        let showTime = null;
        // let timer = setInterval(function () {
        if (startTime) {
          let timezone = 9;
          let offset_GMT = new Date().getTimezoneOffset();
          let nowDate = new Date().getTime();
          let time = sd.format(
            new Date(
              nowDate + offset_GMT * 60 * 1000 + timezone * 60 * 60 * 1000
            ),
            "YYYY-MM-DD HH:mm:ss"
          );
          var answerTime = moment(
            new Date(
              startTime.replace(/T/g, " ").replace(/\.[\d]{3}Z/, "")
            )
          ).format("YYYY-MM-DD HH:mm:ss");
          let outTime = "";
          let hours = moment(time).diff(moment(answerTime), "hours");
          if (hours > 0) {
            if (hours < 10) {
              outTime = outTime + "0" + hours + ":";
            } else {
              outTime = outTime + hours + ":";
            }
          } else {
            outTime = outTime + "00:";
          }
          let minutes = moment(time).diff(moment(answerTime), "minutes") % 60;
          if (minutes > 0) {
            if (minutes < 10) {
              outTime = outTime + "0" + minutes + ":";
            } else {
              outTime = outTime + minutes + ":";
            }
          } else {
            outTime = outTime + "00:";
          }
          let seconds =
            (moment(time).diff(moment(answerTime), "seconds") % 60) % 60;
          if (seconds > 0) {
            if (seconds < 10) {
              outTime = outTime + "0" + seconds;
            } else {
              outTime = outTime + seconds;
            }
          } else {
            outTime = outTime + "00";
          }
          showTime = outTime;

        }
        return showTime;
        // }, 1000)
      }

      function getUserCallRecordForPi(sipNum, modeName, currentTime) {
        let params = {
          sipNum: sipNum,
          modeName: modeName,
          currentTime: currentTime
        }
        // console.log("getUserCallRecordForPi", params);
        api.getUserCallRecordForPi(params).then((res) => {
          state.piRecordInfoObj.piRecordInfo = res.data.data;
          // console.log(" state.piRecordInfo", state.piRecordInfoObj.piRecordInfo)
          let Record_count = 0;
          for (let i of state.piRecordInfoObj.piRecordInfo) {
            Record_count++;
            // let temp = _.find(state.customerList, function (o) { return o.phonenum == i.telnum });//
            // if (temp) {
            //   if(temp.lastname && temp.firstname){
            //     i.customerName = temp.lastname+temp.firstname;
            //   }else{
            //     i.customerName = 'ゲスト';
            //   }
            //   if(temp.logo_url){
            //     i.logo_url = temp.logo_url;
            //   }else{
            //     i.logo_url = questioner_logo;
            //   }
            // }else{
            //   i.logo_url = questioner_logo;
            // }
            // i.timeDiff = null;
            i.timeDiff = getTimeDiff(i.call_end_time);
            // let timer = getTimeDiffTimer(timeDiff);

            // console.log("i.timeDiff",i.timeDiff)
          }
          state.piRecordInfoObj.pi_record_count = Record_count;
          state.piRecordVisible = false;
        }, (err) => {
          console.log('getUserCallRecordForPi', err);
        })
      };

      // function getCurrentTime() {
      //   let myDate = new Date();
      //   let date = moment(myDate).format("YYYYMMDD");
      //   console.log(date)
      //   return date;
      // }

    }, (err) => {
      console.log('get  test pi call info', err);
    })

    console.log("state.piCallInfoObj", state.piCallInfoObj)
  },


  getAllInfoToPi(context, item) {

    let telNum = item.telNum;
    let excludeIssueId = item.excludeIssueId
    piAnalyze(telNum);
    getPiIssues(telNum, excludeIssueId);
    getPiCustomerInfo(telNum);
    getEmpathyMatchingInfo(telNum);
    function piAnalyze(telNum) {
      let params = {
        phonenum: telNum,
        modeName: state.ws_mode,
      };
      api.piAnalyze(params).then(
        (res) => {
          if(res.data != "fail"){
            if (res.data.data.facet_title) {
              state.pimessageVisible = false;
              // console.log("pi", res.data.data);
              if (res.data.data.lastname && res.data.data.firstname) {
                state.customer_name = vueUtils.computeFullName(res.data.data.lastname, res.data.data.firstname);
              } else {
                state.customer_name = "ゲスト";
              }
              state.facet_title = res.data.data.facet_title;
              let temp_facet_value = [];
              for (let i of res.data.data.facet_value) {
                temp_facet_value.push(toPercent(i));
              }
              // console.log( " temp_facet_value",temp_facet_value);
              state.facet_value = temp_facet_value;

              state.facet_value0 = toPercent(res.data.data.facet_value[0]);
              state.facet_message = res.data.data.facet_message;
              state.advice_info = res.data.data.advice_info;
              state.credibility_message = res.data.data.credibility_message;
              state.pi_loading = false;
              state.facetFlg = true;
              state.piEmptyFlg = false;
            } else {
              state.facetFlg = false;
              state.noContentsMessage = state.html_const.cons_265_chat_no_info;
              state.pimessageVisible = true;
              state.pi_loading = false;
              state.piEmptyFlg = true;
            }
          }else{
            state.facetFlg = false;
            state.noContentsMessage = state.html_const.cons_265_chat_no_info;
            state.pimessageVisible = true;
            state.pi_loading = false;
            state.piEmptyFlg = true;
          }


        },
        (err) => {
          console.log("pi error", err);
        }
      )
    }
    function toPercent(point) {
      var str = Number(point * 100).toFixed(0)
      // str += "%";
      str = parseInt(str);
      // console.log(typeof (str))
      return str;
    }

    function getPiIssues(telNum, excludeIssueId) {
      let params = {
        phonenum: telNum,
        modeName: state.ws_mode,
      };
      api.getIssuesInfoForManualChatPiProcss(params).then((res) => {
        console.log(res);
        if(res.data != "fail"){
          if(res.data){
            state.PiIssueList = res.data.data.issues_list;
            // 过滤要排除的票
            if (excludeIssueId && excludeIssueId !== ""){
              state.PiIssueList = state.PiIssueList.filter((o)=> (o.issue_id != excludeIssueId))
            }

            for (let i of state.PiIssueList) {
              if(i.lastname==="AI"){
                i.lastname = "AI "
              }
              i.name = vueUtils.computeFullName(i.lastname, i.firstname)
              let tempTime = i.finish_time
              i.finish_time = moment(tempTime)
              .utcOffset(0)
              .format("YYYY/MM/DD");

              // TODO：db的时间格式统一
              // 暂时策略：画面显示只表示分和秒 mm:ss
              if(i.response_time && i.response_time !==""){
                let response_time_array =  i.response_time.split(":");
                if(response_time_array.length > 2){
                  i.response_time = String(response_time_array[1]).padStart(2, '0') + ":" + String(response_time_array[2]).padStart(2, '0');
                } else {
                  i.response_time = String(response_time_array[0]).padStart(2, '0') + ":" + String(response_time_array[1]).padStart(2, '0');
                }
              }
            }
            state.ngCount = res.data.data.ng_count;
            state.longTimeCount = res.data.data.long_time_count;

            if(state.PiIssueList[0]){
              if(state.PiIssueList[0].category_tag){
                let temp_categoryList = state.PiIssueList[0].category_tag.split(/\s+/g);
                let temp_categoryList2 = [];
                for (let i of temp_categoryList) {
                  if (i) {
                    temp_categoryList2.push(i);
                  }
                }
                state.categoryList = temp_categoryList2;
              }

            }


            if(state.PiIssueList[0]){
              if(state.PiIssueList[0].status_name =="ESCALATION AGT"){
                state.piIssueStatusFlg = true;
              }else{
                state.piIssueStatusFlg = false;
              }
            }
            console.log("state.piIssueStatusFlg",state.piIssueStatusFlg)
            if(state.PiIssueList[0]){
              state.piIssueListEmptyFlg = false;

            }else{
              state.piIssueListEmptyFlg = true;
            }
          }else{
            state.piIssueListEmptyFlg = true;
          }

          state.piIssuesVisible = false;
        }else{
          state.piIssuesVisible = false;
        }

      }, (err) => {
        console.log('getPiIssues', err);
      });
    }
    // state.piIssuesVisible = true;
    function getPiCustomerInfo(telNum) {
      let params = {
        phoneNum: telNum,
        modeName: state.ws_mode
      };
      function padString(obj){
        let str = obj.value.toString();
        let s = '';
        let len = str.length
        if(len < 8){
           let padLen = 8 - len;
           let padStr = '';
           for(let i = 0 ; i < padLen; i++){
            padStr += '0';
           }
           s = padStr + str;
        }else{
          s = str.substring(0,8);
        }
        obj.value = 'AB'+ s;
        return obj;
      }
      api.getPiCustomerInfo(params).then((res) => {
        if(res.data){
          let data = res.data.data;     
          data.customer_name = vueUtils.computeFullName(data.lastname, data.firstname);
          if(data.birthday){
            data.birthday = moment(data.birthday).format("YYYY-MM-DD");
            // birthday
          }
          if(data.create_time){
            data.create_time = moment(data.create_time).format("YYYY-MM-DD");
          }
          if(data.update_time){
            data.update_time = moment(data.update_time).format("YYYY-MM-DD");
          }
          if(data.sex){
            if(data.sex ==1 ){
              data.sex = '男'
            }else if (data.sex == 2){
              data.sex = '女'
            }else{
              data.sex = 'その他'
            }
          }
          for(let i =0;i<Object.keys(data).length;i++){
            if(Object.keys(data)[i]==="lastname"){
              data = omit(
                data,Object.keys(data)[i]
              )
            };
            // if(Object.keys(data)[i]==="firstname"){
            //   data = omit(
            //     data,Object.keys(data)[i]
            //   )
            // };
          }
          for(let i =0;i<Object.keys(data).length;i++){
            // if(Object.keys(data)[i]==="lastname"){
            //   data = omit(
            //     data,Object.keys(data)[i]
            //   )
            // };
            if(Object.keys(data)[i]==="firstname"){
              data = omit(
                data,Object.keys(data)[i]
              )
            };
          }
          let arr = [];
          Object.keys(data).forEach(v => {
            let o = {};
            o[v] = data[v];
            arr.push(o)
          })
          let data2 = data;
          for(let i =0;i<Object.keys(data2).length;i++){

            if(Object.keys(data2)[i]==="country_code"){
              data2 = omit(
                data2,Object.keys(data2)[i]
              )
            };
            if(Object.keys(data2)[i]==="sex"){
              data2 = omit(
                data2,Object.keys(data2)[i]
              )
            };
            if(Object.keys(data2)[i]==="create_time"){
              data2 = omit(
                data2,Object.keys(data2)[i]
              )
            };
            if(Object.keys(data2)[i]==="update_time"){
              data2 = omit(
                data2,Object.keys(data2)[i]
              )
            };
            if(Object.keys(data2)[i]==="former_address"){
              data2 = omit(
                data2,Object.keys(data2)[i]
              )
            };
          }
          let arr2 = [];
          Object.keys(data2).forEach(v => {
            let o = {};
            o[v] = data[v];
            arr2.push(o)
          })
          let list = [];
          let list_1 = [];
          let list2 = [];
          let list2_2 = [];
          for (let i of arr) {
            let obj = {
              "label": Object.keys(i)[0],
              "value": i[Object.keys(i)]
            };
            list.push(obj)
          }
          for (let i of arr2) {
            let obj = {
              "label": Object.keys(i)[0],
              "value": i[Object.keys(i)]
            };
            list_1.push(obj)
          }
          state.customerInfo = list;
      
          let label_name = {
            "phone_number": "架電先番号*",
            "id": "お問い合わせ者ID",
            "customer_name":"名前*",
            // "firstname":"名",
            // "lastname": "姓",
            "mail": "メールアドレス*",
            "sex": "性别",
            "birthday": "生年月日*",
            // "former_address": "前住所",
            "current_address": "住所*",
            "create_time": "登録日",
            "update_time": "更新日",
            "customer_name_yomi":"読み*",
            "company_name": "法人名",
            "company_name_kana": "法人名読み",
            "company_main_phone": "法人代表電話番号",
            "company_contact_person": "法人担当者名",
            "company_contact_phone": "法人担当者電話番号",

          }
          let label_name2 = {
            "phone_number": "架電先番号33*",
            "customer_name":"名前*",
            "mail": "メールアドレス*",
            "birthday": "生年月日*",
            "current_address": "住所*",
            "customer_name_yomi":"読み*",
            "company_name": "法人名",
            "company_name_kana": "法人名読み",
            "company_main_phone": "法人代表電話番号",
            "company_contact_person": "法人担当者名",
            "company_contact_phone": "法人担当者電話番号",
          }
          for (let i of arr) {
            let label = "";
            for (let j of Object.keys(label_name)) {
              if (Object.keys(i)[0] == j) {
                label = label_name[j];
              }
            }
            let obj = {
              "label": label,
              "value": i[Object.keys(i)],
              "label2": "拡張項目",
              "value2": ""
            };
            // console.log("obj", obj);
            list2.push(obj)
          }
          // add for JAL-demo
          // list2[0].label2='JMBお得意様番号'
          // list2[0].value2='123456789'

          for(let i of list2){
            if(i.label == "架電先番号*"){
              state.customerInfo2[0] = i;
            }
            if(i.label == "お問い合わせ者ID"){
              state.customerInfo2[1] = padString(i);
            }
            if(i.label == "名前*"){
              state.customerInfo2[2] = i;
            }
            if(i.label == "読み*"){
              state.customerInfo2[3] = i;
            }
            if(i.label == "メールアドレス*"){
              state.customerInfo2[4] = i;
            }
            if(i.label == "性别"){
              state.customerInfo2[5] = i;
            }
            if(i.label == "生年月日*"){
              state.customerInfo2[6] = i;
            }
            // if(i.label == "前住所"){
            //   state.customerInfo2[7] = i;
            // }
            if(i.label == "住所*"){
              state.customerInfo2[7] = i;
            }
            // 法人名
            if (i.label === "法人名") {
              state.customerInfo2[8] = i;
            }

            // 法人名読み
            if (i.label === "法人名読み") {
              state.customerInfo2[9] = i;
            }

            // 法人代表電話番号
            if (i.label === "法人代表電話番号") {
              state.customerInfo2[10] = i;
            }

            // 法人担当者名
            if (i.label === "法人担当者名") {
              state.customerInfo2[11] = i;
            }

            // 法人担当者電話番号
            if (i.label === "法人担当者電話番号") {
              state.customerInfo2[12] = i;
            }
            if(i.label == "登録日"){
              state.customerInfo2[13] = i;
            }
            if(i.label == "更新日"){
              state.customerInfo2[14] = i;
            }

          }

          state.customerInfo2.sort();
          for (let i of arr2) {
            let label = "";
            for (let j of Object.keys(label_name2)) {
              if (Object.keys(i)[0] == j) {
                label = label_name[j];
              }
            }
            let obj = {
              "label": label,
              "value": i[Object.keys(i)],
              "label2": "拡張項目",
              "value2": ""
            };
            // console.log("obj", obj);
            list2_2.push(obj)
          }
          // add for JAL-demo
          // list2_2[0].label2='JMBお得意様番号'
          // list2_2[0].value2='123456789'

          for(let i of list2_2){
            if(i.label == "架電先番号*"){
              state.customerInfo3[0] = i;
            }
            if(i.label == "名前*"){
              state.customerInfo3[1] = i;
            }
            if(i.label == "読み*"){
              state.customerInfo3[2] = i;
            }
            if(i.label == "住所*"){
              state.customerInfo3[3] = i;
            }
            if(i.label == "メールアドレス*"){
              state.customerInfo3[4] = i;
            }
            if(i.label == "生年月日*"){
              state.customerInfo3[5] = i;
            }
            // 法人名
            if (i.label === "法人名") {
              state.customerInfo3[6] = i;
            }

            // 法人名読み
            if (i.label === "法人名読み") {
              state.customerInfo3[7] = i;
            }

            // 法人代表電話番号
            if (i.label === "法人代表電話番号") {
              state.customerInfo3[8] = i;
            }

            // 法人担当者名
            if (i.label === "法人担当者名") {
              state.customerInfo3[9] = i;
            }

            // 法人担当者電話番号
            if (i.label === "法人担当者電話番号") {
              state.customerInfo3[10] = i;
            }
          }
          state.customerInfo3.sort();
          state.piCustomerVisible = false;
          if(data.customer_name){
            state.piCustomerInfoEmptyFlg = false;
          }else{
            state.piCustomerInfoEmptyFlg = true;
          }
        }else{
          state.piCustomerInfoEmptyFlg = true;
        }

        // console.log("customer:", list);
        // console.log("customer2:", list2);
      }, (err) => {
        console.log('getPiCustomerInfo', err);
      }
      )
    }
    function getEmpathyMatchingInfo(){
      let params = {
        user_phoneNum:telNum,
        // user_phoneNum:'01006',
        login_email:state.login_id,
        token:state.empathyMatChingToken,
        modeName: state.ws_mode,
        chatStatus:"",
      }
      try{
        api.getEmpathyMatchingInfo(params).then((res)=>{
          if(res.data != "fail" && res.data.data.empathy50){
            if(res.data.data.empathy50<0.3){
              let temp_similarity = 0.3*(0.7+res.data.data.empathy50);
              state.heart_change_distance = (1- temp_similarity)*50;
              state.heart_change_distance_big = (1- temp_similarity)*60;
            }else{
              state.heart_change_distance = (1- res.data.data.empathy50)*50;
              state.heart_change_distance_big = (1- res.data.data.empathy50)*60;
            }
            state.similarity = toPercent(res.data.data.empathy50) + "%";
            console.log(res)
          }else{
            state.similarity = 'fail';
            console.log("fail")
          }

        }),(err)=>{
          console.log("pi error", err);
        }
      }catch(err){
        console.log(err);
      }

    }


  },



  searchDetail_getAllInfoToPi(context, item) {

    let telNum = item.telNum;
    piAnalyze(telNum);
    getPiIssues(telNum);
    getPiCustomerInfo(telNum);
    getEmpathyMatchingInfo(telNum);
    function piAnalyze(telNum) {
      let params = {
        phonenum: telNum,
        modeName: state.ws_mode,
      };
      api.piAnalyze(params).then(
        (res) => {
          if(res.data != "fail"){
            if (res.data.data.facet_title) {
              state.searchDetail_pimessageVisible = false;
              // console.log("pi", res.data.data);
              if (res.data.data.lastname && res.data.data.firstname) {
                state.searchDetail_customer_name = vueUtils.computeFullName(res.data.data.lastname, res.data.data.firstname);
              } else {
                state.searchDetail_customer_name = state.html_const.cons_217_questioner;
              }
              state.searchDetail_facet_title = res.data.data.facet_title;
              let temp_facet_value = [];
              for (let i of res.data.data.facet_value) {
                temp_facet_value.push(toPercent(i));
              }
              // console.log( " temp_facet_value",temp_facet_value);
              state.searchDetail_facet_value = temp_facet_value;

              state.searchDetail_facet_value0 = toPercent(res.data.data.facet_value[0]);
              state.searchDetail_facet_message = res.data.data.facet_message;
              state.searchDetail_advice_info = res.data.data.advice_info;
              state.searchDetail_credibility_message = res.data.data.credibility_message;
              state.searchDetail_pi_loading = false;
              state.searchDetail_facetFlg = true;
              state.searchDetail_piEmptyFlg = false;
            } else {
              state.searchDetail_facetFlg = false;
              state.searchDetail_noContentsMessage = state.html_const.cons_265_chat_no_info;
              state.searchDetail_pimessageVisible = true;
              state.searchDetail_pi_loading = false;
              state.searchDetail_piEmptyFlg = true;
            }
          }else{
            state.searchDetail_facetFlg = false;
            state.searchDetail_noContentsMessage = state.html_const.cons_265_chat_no_info;
            state.searchDetail_pimessageVisible = true;
            state.searchDetail_pi_loading = false;
            state.searchDetail_piEmptyFlg = true;
          }


        },
        (err) => {
          console.log("pi error", err);
        }
      )
    }
    function toPercent(point) {
      var str = Number(point * 100).toFixed(0)
      // str += "%";
      str = parseInt(str);
      // console.log(typeof (str))
      return str;
    }

    function getPiIssues(telNum) {
      let params = {
        phonenum: telNum,
        modeName: state.ws_mode,
      };
      api.getIssuesInfoForManualChatPiProcss(params).then((res) => {
        console.log(res);
        if(res.data != "fail"){
          if(res.data){
            state.searchDetail_PiIssueList = res.data.data.issues_list;
            for (let i of state.PiIssueList) {
              if(i.lastname==="AI"){
                i.lastname = "AI "
              }
              i.name = vueUtils.computeFullName(i.lastname, i.firstname)
              let tempTime = i.finish_time
              i.finish_time = moment(tempTime)
              .utcOffset(0)
              .format("YYYY/MM/DD");
            }
            state.searchDetail_ngCount = res.data.data.ng_count;
            state.searchDetail_longTimeCount = res.data.data.long_time_count;

            if(res.data.data.issues_list[0]){
              if(res.data.data.issues_list[0].category_tag){
                let temp_categoryList = res.data.data.issues_list[0].category_tag.split(/\s+/g);
                let temp_categoryList2 = [];
                for (let i of temp_categoryList) {
                  if (i) {
                    temp_categoryList2.push(i);
                  }
                }
                state.searchDetail_categoryList = temp_categoryList2;
              }

            }


            if(res.data.data.issues_list[0]){
              if(res.data.data.issues_list[0].status_name =="ESCALATION AGT"){
                state.searchDetail_piIssueStatusFlg = true;
              }else{
                state.searchDetail_piIssueStatusFlg = false;
              }
            }
            console.log("state.searchDetail_piIssueStatusFlg",state.searchDetail_piIssueStatusFlg)
            if(res.data.data.issues_list[0]){
              state.searchDetail_piIssueListEmptyFlg = false;

            }else{
              state.searchDetail_piIssueListEmptyFlg = true;
            }
          }else{
            state.searchDetail_piIssueListEmptyFlg = true;
          }

          state.searchDetail_piIssuesVisible = false;
        }else{
          state.searchDetail_piIssuesVisible = false;
        }

      }, (err) => {
        console.log('getPiIssues', err);
      });
    }
    // state.piIssuesVisible = true;
    function getPiCustomerInfo(telNum) {
      let params = {
        phoneNum: telNum,
        modeName: state.ws_mode
      };
      function padString(obj){
        let str = obj.value.toString();
        let s = '';
        let len = str.length
        if(len < 8){
           let padLen = 8 - len;
           let padStr = '';
           for(let i = 0 ; i < padLen; i++){
            padStr += '0';
           }
           s = padStr + str;
        }else{
          s = str.substring(0,8);
        }
        obj.value = 'AB'+ s;
        return obj;
      }
      api.getPiCustomerInfo(params).then((res) => {
        if(res.data){
          let data = res.data.data;
          data.customer_name = vueUtils.computeFullName(data.lastname, data.firstname);
          if(data.birthday){
            data.birthday = moment(data.birthday).format("YYYY-MM-DD");
            // birthday
          }
          if(data.create_time){
            data.create_time = moment(data.create_time).format("YYYY-MM-DD");
          }
          if(data.update_time){
            data.update_time = moment(data.update_time).format("YYYY-MM-DD");
          }
          if(data.sex){
            if(data.sex ==1 ){
              data.sex = '男'
            }else if (data.sex == 2){
              data.sex = '女'
            }else{
              data.sex = 'その他'
            }
          }
          for(let i =0;i<Object.keys(data).length;i++){
            if(Object.keys(data)[i]==="lastname"){
              data = omit(
                data,Object.keys(data)[i]
              )
            };
            // if(Object.keys(data)[i]==="firstname"){
            //   data = omit(
            //     data,Object.keys(data)[i]
            //   )
            // };
          }
          for(let i =0;i<Object.keys(data).length;i++){
            // if(Object.keys(data)[i]==="lastname"){
            //   data = omit(
            //     data,Object.keys(data)[i]
            //   )
            // };
            if(Object.keys(data)[i]==="firstname"){
              data = omit(
                data,Object.keys(data)[i]
              )
            };
          }
          let arr = [];
          Object.keys(data).forEach(v => {
            let o = {};
            o[v] = data[v];
            arr.push(o)
          })
          let data2 = data;
          for(let i =0;i<Object.keys(data2).length;i++){

            if(Object.keys(data2)[i]==="country_code"){
              data2 = omit(
                data2,Object.keys(data2)[i]
              )
            };
            if(Object.keys(data2)[i]==="sex"){
              data2 = omit(
                data2,Object.keys(data2)[i]
              )
            };
            if(Object.keys(data2)[i]==="create_time"){
              data2 = omit(
                data2,Object.keys(data2)[i]
              )
            };
            if(Object.keys(data2)[i]==="update_time"){
              data2 = omit(
                data2,Object.keys(data2)[i]
              )
            };
            if(Object.keys(data2)[i]==="former_address"){
              data2 = omit(
                data2,Object.keys(data2)[i]
              )
            };
          }
          let arr2 = [];
          Object.keys(data2).forEach(v => {
            let o = {};
            o[v] = data[v];
            arr2.push(o)
          })
          let list = [];
          let list_1 = [];
          let list2 = [];
          let list2_2 = [];
          for (let i of arr) {
            let obj = {
              "label": Object.keys(i)[0],
              "value": i[Object.keys(i)]
            };
            list.push(obj)
          }
          for (let i of arr2) {
            let obj = {
              "label": Object.keys(i)[0],
              "value": i[Object.keys(i)]
            };
            list_1.push(obj)
          }
          state.searchDetail_customerInfo = list;
          let label_name = {
            "phone_number": "架電先番号*",
            "id": "お問い合わせ者ID",
            "customer_name":"名前*",
            // "firstname":"名",
            // "lastname": "姓",
            "mail": "メールアドレス*",
            "sex": "性别",
            "birthday": "生年月日*",
            // "former_address": "前住所",
            "current_address": "住所*",
            "company_name": "法人名",
            "company_name_kana": "法人名読み",
            "company_main_phone": "法人代表電話番号",
            "company_contact_person": "法人担当者名",
            "company_contact_phone": "法人担当者電話番号",
            "create_time": "登録日",
            "update_time": "更新日",
            "customer_name_yomi":"読み*",

          }
          let label_name2 = {
            "phone_number": "架電先番号*",
            "customer_name":"名前*",
            "mail": "メールアドレス*",
            "birthday": "生年月日*",
            "current_address": "住所*",
            "customer_name_yomi":"読み*",
            "company_name": "法人名",
            "company_name_kana": "法人名読み",
            "company_main_phone": "法人代表電話番号",
            "company_contact_person": "法人担当者名",
            "company_contact_phone": "法人担当者電話番号",
          }
          for (let i of arr) {
            let label = "";
            for (let j of Object.keys(label_name)) {
              if (Object.keys(i)[0] == j) {
                label = label_name[j];
              }
            }
            let obj = {
              "label": label,
              "value": i[Object.keys(i)],
              "label2": "拡張項目",
              "value2": ""
            };
            // console.log("obj", obj);
            list2.push(obj)
          }
          // add for JAL-demo
          // list2[0].label2='JMBお得意様番号'
          // list2[0].value2='123456789'

          for(let i of list2){
            if(i.label == "架電先番号*"){
              state.searchDetail_customerInfo2[0] = i;
            }
            if(i.label == "お問い合わせ者ID"){
              state.searchDetail_customerInfo2[1] = padString(i);
            }
            if(i.label == "名前*"){
              state.searchDetail_customerInfo2[2] = i;
            }
            if(i.label == "読み*"){
              state.searchDetail_customerInfo2[3] = i;
            }
            if(i.label == "メールアドレス*"){
              state.searchDetail_customerInfo2[4] = i;
            }
            if(i.label == "性别"){
              state.searchDetail_customerInfo2[5] = i;
            }
            if(i.label == "生年月日*"){
              state.searchDetail_customerInfo2[6] = i;
            }
            // if(i.label == "前住所"){
            //   state.searchDetail_customerInfo2[7] = i;
            // }
            if(i.label == "住所*"){
              state.searchDetail_customerInfo2[7] = i;
            }

            // 法人名
            if (i.label === "法人名") {
              state.searchDetail_customerInfo2[8] = i;
            }

            // 法人名読み
            if (i.label === "法人名読み") {
              state.searchDetail_customerInfo2[9] = i;
            }

            // 法人代表電話番号
            if (i.label === "法人代表電話番号") {
              state.searchDetail_customerInfo2[10] = i;
            }

            // 法人担当者名
            if (i.label === "法人担当者名") {
              state.searchDetail_customerInfo2[11] = i;
            }

            // 法人担当者電話番号
            if (i.label === "法人担当者電話番号") {
              state.searchDetail_customerInfo2[12] = i;
            }
            if(i.label == "登録日"){
              state.searchDetail_customerInfo2[13] = i;
            }
            if(i.label == "更新日"){
              state.searchDetail_customerInfo2[14] = i;
            }
          }

          state.searchDetail_customerInfo2.sort();
          for (let i of arr2) {
            let label = "";
            for (let j of Object.keys(label_name2)) {
              if (Object.keys(i)[0] == j) {
                label = label_name[j];
              }
            }
            let obj = {
              "label": label,
              "value": i[Object.keys(i)],
              "label2": "拡張項目",
              "value2": ""
            };
            console.log("1111obj11111", obj);
            list2_2.push(obj)
          }
          // add for JAL-demo
          // list2_2[0].label2='JMBお得意様番号'
          // list2_2[0].value2='123456789'
          for(let i of list2_2){
            if(i.label == "架電先番号*"){
              state.searchDetail_customerInfo3[0] = i;
            }
            if(i.label == "名前*"){
              state.searchDetail_customerInfo3[1] = i;
            }
            if(i.label == "読み*"){
              state.searchDetail_customerInfo3[2] = i;
            }
            if(i.label == "住所*"){
              state.searchDetail_customerInfo3[3] = i;
            }
            if(i.label == "メールアドレス*"){
              state.searchDetail_customerInfo3[4] = i;
            }
            if(i.label == "生年月日*"){
              state.searchDetail_customerInfo3[5] = i;
            }
            // 法人名
            if (i.label === "法人名") {
              state.searchDetail_customerInfo3[6] = i;
            }

            // 法人名読み
            if (i.label === "法人名読み") {
              state.searchDetail_customerInfo3[7] = i;
            }

            // 法人代表電話番号
            if (i.label === "法人代表電話番号") {
              state.searchDetail_customerInfo3[8] = i;
            }

            // 法人担当者名
            if (i.label === "法人担当者名") {
              state.searchDetail_customerInfo3[9] = i;
            }

            // 法人担当者電話番号
            if (i.label === "法人担当者電話番号") {
              state.searchDetail_customerInfo3[10] = i;
            }
          }
          state.searchDetail_customerInfo3.sort();
          state.searchDetail_piCustomerVisible = false;
          if(data.customer_name){
            state.searchDetail_piCustomerInfoEmptyFlg = false;
          }else{
            state.searchDetail_piCustomerInfoEmptyFlg = true;
          }
        }else{
          state.searchDetail_piCustomerInfoEmptyFlg = true;
        }

        // console.log("customer:", list);
        // console.log("customer2:", list2);
      }, (err) => {
        console.log('getPiCustomerInfo', err);
      }
      )
      
    }
    function getEmpathyMatchingInfo(){
      let params = {
        user_phoneNum:telNum,
        // user_phoneNum:'01006',
        login_email:state.login_id,
        token:state.empathyMatChingToken,
        modeName: state.ws_mode,
        chatStatus:"",
      }
      try{
        api.getEmpathyMatchingInfo(params).then((res)=>{
          if(res.data != "fail" && res.data.data.empathy50){
            if(res.data.data.empathy50<0.3){
              let temp_similarity = 0.3*(0.7+res.data.data.empathy50);
              state.searchDetail_heart_change_distance = (1- temp_similarity)*50;
              state.heart_change_distance_big = (1- temp_similarity)*60;
            }else{
              state.searchDetail_heart_change_distance = (1- res.data.data.empathy50)*50;
              state.searchDetail_heart_change_distance_big = (1- res.data.data.empathy50)*60;
            }
            state.searchDetail_similarity = toPercent(res.data.data.empathy50) + "%";
            console.log(res)
          }else{
            state.searchDetail_similarity = 'fail';
            console.log("fail")
          }

        }),(err)=>{
          console.log("pi error", err);
        }
      }catch(err){
        console.log(err);
      }

    }


  },

  // getIssuesInfoForManualChatPiProcss
  getAllInfoToManualChatPi(context, item) {
    let telNum = item.telNum;
    let chatStatus = item.chatStatus
    let excludeIssueId = item.excludeIssueId
    piAnalyze(telNum);
    getPiIssues(telNum, excludeIssueId);
    getPiCustomerInfo(telNum);
    getEmpathyMatchingInfo(telNum);
    function piAnalyze(telNum) {
      let params = {
        phonenum: telNum,
        modeName: state.ws_mode,
        chatStatus:chatStatus,
      };
      api.piAnalyze(params).then(
        (res) => {
          if(res.data != "fail"){
            if (res.data.data.facet_title) {
              state.pimessageVisible = false;
              // console.log("pi", res.data.data);
              if (res.data.data.lastname && res.data.data.firstname) {
                state.customer_name = vueUtils.computeFullName(res.data.data.lastname, res.data.data.firstname);
              } else {
                state.customer_name = "ゲスト";
              }
              // state.facet_title = "["+res.data.data.facet_title+"]な";
              state.facet_title = res.data.data.facet_title;

              let temp_facet_value = [];
              for (let i of res.data.data.facet_value) {
                temp_facet_value.push(toPercent(i));
              }
              // console.log( " temp_facet_value",temp_facet_value);
              state.facet_value = temp_facet_value;

              state.facet_value0 = toPercent(res.data.data.facet_value[0]);
              state.facet_message = res.data.data.facet_message;
              state.advice_info = res.data.data.advice_info;
              state.credibility_message = res.data.data.credibility_message;
              state.pi_loading = false;
              state.facetFlg = true;
              state.piEmptyFlg = false;
            } else {
              state.facetFlg = false;
              state.noContentsMessage = state.html_const.cons_265_chat_no_info;//まだ情報がありません
              state.pimessageVisible = true;
              state.pi_loading = false;
              state.piEmptyFlg = true;
            }
          }else{
            state.facetFlg = false;
            state.noContentsMessage = state.html_const.cons_265_chat_no_info;;
            state.pimessageVisible = true;
            state.pi_loading = false;
            state.piEmptyFlg = true;
          }


        },
        (err) => {
          console.log("pi error", err);
        }
      )
    }
    function toPercent(point) {
      var str = Number(point * 100).toFixed(0)
      // str += "%";
      str = parseInt(str);
      // console.log(typeof (str))
      return str;
    }

    

    function getPiIssues(telNum, excludeIssueId) {
      let params = {
        // userId: telNum,
        phonenum: telNum,
        modeName: state.ws_mode,
        chatStatus:chatStatus,
      };
      api.getIssuesInfoForManualChatPiProcss(params).then((res) => {
        console.log(res);
        if(res.data != "fail" && res.data.data.issues_list.length>0){
          if(res.data){
            state.PiIssueList = res.data.data.issues_list;
            // 过滤要排除的票
            if (excludeIssueId && excludeIssueId !== ""){
              state.PiIssueList = state.PiIssueList.filter((o)=> (o.issue_id != excludeIssueId))
            }
          for (let i of state.PiIssueList) {
            if(i.lastname==="AI"){
              i.lastname = "AI "
            }
            i.name = vueUtils.computeFullName(i.lastname, i.firstname)
            let tempTime = i.finish_time
            i.finish_time = moment(tempTime)
            .utcOffset(0)
            .format("YYYY/MM/DD");

            // TODO：db的时间格式统一
            // 暂时策略：画面显示只表示分和秒 mm:ss
            if(i.response_time && i.response_time !==""){
              let response_time_array =  i.response_time.split(":");
              if(response_time_array.length > 2){
                i.response_time = String(response_time_array[1]).padStart(2, '0') + ":" + String(response_time_array[2]).padStart(2, '0')
              } else {
                i.response_time = String(response_time_array[0]).padStart(2, '0') + ":" + String(response_time_array[1]).padStart(2, '0')
              }
            }
          }
          state.ngCount = res.data.data.ng_count;
          state.longTimeCount = res.data.data.long_time_count;
          if(state.PiIssueList[0].category_tag){
            let temp_categoryList = state.PiIssueList[0].category_tag.split(/\s+/g);
            let temp_categoryList2 = [];
            for (let i of temp_categoryList) {
              if (i) {
                temp_categoryList2.push(i);
              }
            }
            state.categoryList = temp_categoryList2;
          }

          if(state.PiIssueList[0].hasOwnProperty('status_name')){
            if(state.PiIssueList[0].status_name =="ESCALATION AGT"){
              state.piIssueStatusFlg = true;
            }else{
              state.piIssueStatusFlg = false;
            }
            console.log("state.piIssueStatusFlg",state.piIssueStatusFlg)
          }
          state.piIssueListEmptyFlg = false;
          }else{
            state.piIssueListEmptyFlg = true;
          }
          state.piIssuesVisible = false;
        }else{
          state.piIssuesVisible = false;
        }

      }, (err) => {
        console.log('getPiIssues', err);
      });
    }
    // state.piIssuesVisible = true;
    function getPiCustomerInfo(telNum) {
      let params = {
        phoneNum: telNum,
        modeName: state.ws_mode,
        chatStatus:chatStatus,
      };
      function padString(obj){
        let str = obj.value.toString();
        let s = '';
        let len = str.length
        if(len < 8){
           let padLen = 8 - len;
           let padStr = '';
           for(let i = 0 ; i < padLen; i++){
            padStr += '0';
           }
           s = padStr + str;
        }else{
          s = str.substring(0,8);
        }
        obj.value = 'AB'+ s;
        return obj;
      }
      api.getPiCustomerInfo(params).then((res) => {
        if(res.data){
          let data = res.data.data;
          data.customer_name = vueUtils.computeFullName(data.lastname, data.firstname);
          if(data.birthday){
            data.birthday = moment(data.birthday).format("YYYY-MM-DD");
            // birthday
          }
          if(data.create_time){
            data.create_time = moment(data.create_time).format("YYYY-MM-DD");
          }
          if(data.update_time){
            data.update_time = moment(data.update_time).format("YYYY-MM-DD");
          }
          if(data.sex){
            if(data.sex ==1 ){
              data.sex = '男'
            }else if (data.sex == 2){
              data.sex = '女'
            }else{
              data.sex = 'その他'
            }
          }


          for(let i =0;i<Object.keys(data).length;i++){
            if(Object.keys(data)[i]==="lastname"){
              data = omit(
                data,Object.keys(data)[i]
              )
            };
            // if(Object.keys(data)[i]==="firstname"){
            //   data = omit(
            //     data,Object.keys(data)[i]
            //   )
            // };
          }
          for(let i =0;i<Object.keys(data).length;i++){
            // if(Object.keys(data)[i]==="lastname"){
            //   data = omit(
            //     data,Object.keys(data)[i]
            //   )
            // };
            if(Object.keys(data)[i]==="firstname"){
              data = omit(
                data,Object.keys(data)[i]
              )
            };
          }

          let arr = [];
          Object.keys(data).forEach(v => {
            let o = {};
            o[v] = data[v];
            arr.push(o)
          })
          console.log(data)

          let data2 = data;
          for(let i =0;i<Object.keys(data2).length;i++){

            if(Object.keys(data2)[i]==="country_code"){
              data2 = omit(
                data2,Object.keys(data2)[i]
              )
            };
            if(Object.keys(data2)[i]==="sex"){
              data2 = omit(
                data2,Object.keys(data2)[i]
              )
            };
            if(Object.keys(data2)[i]==="create_time"){
              data2 = omit(
                data2,Object.keys(data2)[i]
              )
            };
            if(Object.keys(data2)[i]==="update_time"){
              data2 = omit(
                data2,Object.keys(data2)[i]
              )
            };
            if(Object.keys(data2)[i]==="former_address"){
              data2 = omit(
                data2,Object.keys(data2)[i]
              )
            };
          }
          let arr2 = [];
          Object.keys(data2).forEach(v => {
            let o = {};
            o[v] = data[v];
            arr2.push(o)
          })
          let list = [];
          let list_1 = [];
          let list2 = [];
          let list2_2 = [];
          for (let i of arr) {
            let obj = {
              "label": Object.keys(i)[0],
              "value": i[Object.keys(i)]
            };
            list.push(obj)
          }
          for (let i of arr2) {
            let obj = {
              "label": Object.keys(i)[0],
              "value": i[Object.keys(i)]
            };
            list_1.push(obj)
          }
          state.customerInfo = list;
          let label_name = {
            "phone_number": "架電先番号*",
            "id": "お問い合わせ者ID",
            "customer_name":"名前*",
            // "firstname":"名",
            // "lastname": "姓",
            "mail": "メールアドレス*",
            "sex": "性别",
            "birthday": "生年月日*",
            // "former_address": "前住所",
            "current_address": "住所*",
            "company_name": "法人名",
            "company_name_kana": "法人名読み",
            "company_main_phone": "法人代表電話番号",
            "company_contact_person": "法人担当者名",
            "company_contact_phone": "法人担当者電話番号",
            "create_time": "登録日",
            "update_time": "更新日",
            "customer_name_yomi":"読み*",

          }
          let label_name2 = {
            "phone_number": "架電先番号*",
            "customer_name":"名前*",
            "mail": "メールアドレス*",
            "birthday": "生年月日*",
            "current_address": "住所*",
            "customer_name_yomi":"読み*",
            "company_name": "法人名",
            "company_name_kana": "法人名読み",
            "company_main_phone": "法人代表電話番号",
            "company_contact_person": "法人担当者名",
            "company_contact_phone": "法人担当者電話番号",
          }
          for (let i of arr) {
            let label = "";
            for (let j of Object.keys(label_name)) {
              if (Object.keys(i)[0] == j) {
                label = label_name[j];
              }
            }
            let obj = {
              "label": label,
              "value": i[Object.keys(i)],
              "label2": "拡張項目",
              "value2": ""
            };
            // console.log("obj", obj);
            list2.push(obj)
          }
          // add for JAL-demo
          // list2[0].label2='JMBお得意様番号'
          // list2[0].value2='123456789'
          for(let i of list2){
            if(i.label == "架電先番号*"){
              state.customerInfo2[0] = i;
            }
            if(i.label == "お問い合わせ者ID"){
              state.customerInfo2[1] = padString(i);
            }
            if(i.label == "名前*"){
              state.customerInfo2[2] = i;
            }
            if(i.label == "読み*"){
              state.customerInfo2[3] = i;
            }
            if(i.label == "メールアドレス*"){
              state.customerInfo2[4] = i;
            }
            if(i.label == "性别"){
              state.customerInfo2[5] = i;
            }
            if(i.label == "生年月日*"){
              state.customerInfo2[6] = i;
            }
            // if(i.label == "前住所"){
            //   state.customerInfo2[7] = i;
            // }
            if(i.label == "住所*"){
              state.customerInfo2[7] = i;
            }
            // 法人名
            if (i.label === "法人名") {
              state.customerInfo2[8] = i;
            }

            // 法人名読み
            if (i.label === "法人名読み") {
              state.customerInfo2[9] = i;
            }

            // 法人代表電話番号
            if (i.label === "法人代表電話番号") {
              state.customerInfo2[10] = i;
            }

            // 法人担当者名
            if (i.label === "法人担当者名") {
              state.customerInfo2[11] = i;
            }

            // 法人担当者電話番号
            if (i.label === "法人担当者電話番号") {
              state.customerInfo2[12] = i;
            }
            if(i.label == "登録日"){
              state.customerInfo2[13] = i;
            }
            if(i.label == "更新日"){
              state.customerInfo2[14] = i;
            }

          }

          state.customerInfo2.sort();

          for (let i of arr2) {
            let label = "";
            for (let j of Object.keys(label_name2)) {
              if (Object.keys(i)[0] == j) {
                label = label_name[j];
              }
            }
            let obj = {
              "label": label,
              "value": i[Object.keys(i)],
              "label2": "拡張項目",
              "value2": ""
            };
            // console.log("obj", obj);
            list2_2.push(obj)
          }
          // state.customerInfo3 = list2_2;
          // add for JAL-demo
          // list2_2[0].label2='JMBお得意様番号'
          // list2_2[0].value2='123456789'

          for(let i of list2_2){
            if(i.label == "架電先番号*"){
              state.customerInfo3[0] = i;
            }
            if(i.label == "名前*"){
              state.customerInfo3[1] = i;
            }
            if(i.label == "読み*"){
              state.customerInfo3[2] = i;
            }
            if(i.label == "住所*"){
              state.customerInfo3[3] = i;
            }
            if(i.label == "メールアドレス*"){
              state.customerInfo3[4] = i;
            }
            if(i.label == "生年月日*"){
              state.customerInfo3[5] = i;
            }
            // 法人名
            if (i.label === "法人名") {
              state.customerInfo3[6] = "法人名";
            }

            // 法人名読み
            if (i.label === "法人名読み") {
              state.customerInfo3[7] = i;
            }

            // 法人代表電話番号
            if (i.label === "法人代表電話番号") {
              state.customerInfo3[8] = i;
            }

            // 法人担当者名
            if (i.label === "法人担当者名") {
              state.customerInfo3[9] = i;
            }

            // 法人担当者電話番号
            if (i.label === "法人担当者電話番号") {
              state.customerInfo3[10] = i;
            }
          }
          state.customerInfo3.sort();
          debugger
          console.log("state.customerInfo3", state.customerInfo3)
          state.piCustomerVisible = false;
          state.piCustomerInfoEmptyFlg = false;
        }else{
          state.piCustomerInfoEmptyFlg = true;
        }
        

        // console.log("customer:", list);
        // console.log("customer2:", list2);
      }, (err) => {
        console.log('getPiCustomerInfo', err);
      }
      )
    }

    function getEmpathyMatchingInfo(){
      let params = {
        user_phoneNum:telNum,
        // user_phoneNum:'01006',
        login_email:state.login_id,
        token:state.empathyMatChingToken,
        modeName: state.ws_mode,
        chatStatus:chatStatus,
      }
      try{
        api.getEmpathyMatchingInfo(params).then((res)=>{
          if(res.data != "fail" && res.data.data.empathy50){
            if(res.data.data.empathy50<0.3){
              let temp_similarity = 0.3*(0.7+res.data.data.empathy50);
              state.heart_change_distance = (1- temp_similarity)*50;
              state.heart_change_distance_big = (1- temp_similarity)*60;
            }else{
              state.heart_change_distance = (1- res.data.data.empathy50)*50;
              state.heart_change_distance_big = (1- res.data.data.empathy50)*60;
            }
            state.similarity = toPercent(res.data.data.empathy50) + "%";

            console.log(res)
          }else{
            state.similarity = 'fail';
            console.log("fail")
          }

        }),(err)=>{
          console.log("pi error", err);
        }
      }catch(err){
        console.log(err);
      }

    }
  },


  // mannul chat
  //get mannul chat current time

  getManualChatCurrentTime(context, item) {


    let myDate = new Date();
    let date = moment(myDate).format("YYYYMMDD");
    let currentTime = date;
    let params = {
      operatorId: state.user_id,
      modeName: state.ws_mode,
      currentTime: currentTime
    }

    api.getAllCustomerName().then((res) => {
      // console.log("getAllCustomerName", res.data.data)
      context.commit('changeAllCustomer', res.data.data);
      api.getCurrentManualChatStatus(params).then((res) => {

        state.presenceInfoObj.chating = res.data.result.chating;
        console.log('s=',JSON.stringify(state.presenceInfoObj.chating));
        //empathy
        for(let i of state.presenceInfoObj.chating){
          i["heart_change_distance"] = null;
          i["similarity"] = null;
          i['userOnChecked']= false;
        }

        for(let i of state.presenceInfoObj.chating){
          let temp_params = {
            user_phoneNum:i.id,
            // user_phoneNum:'01006',
            login_email:state.login_id,
            token:state.empathyMatChingToken,
            modeName: state.ws_mode,
            chatStatus:"",
          }
          let temp_heart_change_distance = null;
          let temp_similarity = null;
          try{
            api.getEmpathyMatchingInfo(temp_params).then((res)=>{
                if(res.data != "fail" && res.data.data.empathy50){
                  if(res.data.data.empathy50<0.3){
                    let temp_similarity = 0.3*(0.7+res.data.data.empathy50);
                    temp_heart_change_distance = (1- temp_similarity)*50;
                  }else{
                    temp_heart_change_distance = (1- res.data.data.empathy50)*50;
                  }
                  // temp_similarity = toPercent(res.data.data.empathy50) + "%";
                  if(res.data.data.empathy50){
                    temp_similarity = toPercent(res.data.data.empathy50) + "%";
                    i.similarity = temp_similarity;
                  } else{
                    temp_similarity = '--%';
                    i.similarity = temp_similarity;
                  }
                  i.heart_change_distance = temp_heart_change_distance;
                  // i.similarity = temp_similarity;
                  if(state.chat_ChatingSortByTimeFlg){
                    // state.presenceInfoObj.chating =   _.orderBy(state.presenceInfoObj.chating,['startTime'],['desc']);
                    state.presenceInfoObj.chating =  _.sortBy (state.presenceInfoObj.chating, function(o) { return o.startTime}).reverse();
                  }else{
                    // state.presenceInfoObj.chating =   _.orderBy(state.presenceInfoObj.chating,['similarity'],['desc']);
                    state.presenceInfoObj.chating =  _.sortBy (state.presenceInfoObj.chating, function(o) { return o.startTime}).reverse();
                  }

                  console.log("empathyinfo--->",state.presenceInfoObj.chating)
                }else{
                  temp_similarity = '--%';
                  i.heart_change_distance = temp_heart_change_distance;
                  i.similarity = temp_similarity;
                  if(state.chat_ChatingSortByTimeFlg){
                    // state.presenceInfoObj.chating =   _.orderBy(state.presenceInfoObj.chating,['startTime'],['desc']);
                    state.presenceInfoObj.chating =  _.sortBy (state.presenceInfoObj.chating, function(o) { return o.startTime}).reverse();
                  }else{
                    // state.presenceInfoObj.chating =   _.orderBy(state.presenceInfoObj.chating,['similarity'],['desc']);
                    state.presenceInfoObj.chating =  _.sortBy (state.presenceInfoObj.chating, function(o) { return o.startTime}).reverse();
                  }
                  console.log("fail")
                }

              }),(err)=>{
                console.log("pi error", err);
              }
            }catch(err){
              console.log(err);
            }
        }
        if(state.presenceInfoObj.chating.length>0){
          for(let i of state.presenceInfoObj.chating){
            // if(i.id == state.manualChatQuestionerId && i.issueId == state.manualChatModeIssueId){
            //   i.userOnChecked = true;
            // }
            let temp = _.find(state.customerList, function (o) { return o.phonenum == i.id });//
            if(temp){
              if(temp.logo_url){
                i.logo_url = temp.logo_url;
              }else{
                i.logo_url = questioner_logo;
              }
            }else{
              try{
                let params = {
                  phonenum:i.id
                }
                api.getCustomerInfoByNum(params).then((res)=>{
                  console.log(res);
                  if(res.data != 'fail'){
                    if(res.data.data[0].logo_url){
                      i.logo_url = res.data.data[0].logo_url;
                    }else{
                      i.logo_url = questioner_logo;
                    }
                  }

                },(err)=>{
                  console.log(err);
                })

              }catch(err){
                console.log(err);
              }
              // i.logo_url = questioner_logo;
            }
          }
        }

        if(state.piRefresh){
          if(state.presenceInfoObj.chating.length>0){


            for(let i of state.presenceInfoObj.chating){
              let temp = _.find(state.customerList, function (o) { return o.phonenum == i.id });//
            if(temp){
              if(temp.logo_url){
                i.logo_url = temp.logo_url;
              }else{
                i.logo_url = questioner_logo;
              }
            }else{
              try{
                let params = {
                  phonenum:i.id
                }
                api.getCustomerInfoByNum(params).then((res)=>{
                  console.log(res);
                  if(res.data != 'fail'){
                    if(res.data.data[0].logo_url){
                      i.logo_url = res.data.data[0].logo_url;
                    }else{
                      i.logo_url = questioner_logo;
                    }
                  }

                },(err)=>{
                  console.log(err);
                })

              }catch(err){
                console.log(err);
              }
              // i.logo_url = questioner_logo;
            }
            console.log(" i.logo_url", i.logo_url);
            }

            let params = {
            userId : state.user_id,
            status:"OnThePhone"
          }
          api.changePiStatus(params).then((res)=>{

            state.manualChatPiStatus = "OnThePhone";

        })



            state.manualChatUserCount = state.presenceInfoObj.chating.length;
            let tempCount = state.currentUserCount+1;
            if(state.manualChatUserCount >= tempCount){
              state.manualButtonDisabled = true;
            }

            state.piRefresh = false;
          }
        }



        for (let i of state.presenceInfoObj.chating) {
          i.buttonStatus = "close";
        }
        state.presenceInfoObj.waiting = res.data.result.waiting;
        //empathy:

        for(let i of state.presenceInfoObj.waiting){
          i["current_waiting"] = false;
          i["heart_change_distance"] = null;
          i["similarity"] = null;
        }

        for(let i of state.presenceInfoObj.waiting){
          let temp_params = {
            user_phoneNum:i.id,
            // user_phoneNum:'01006',
            login_email:state.login_id,
            token:state.empathyMatChingToken,
            modeName: state.ws_mode,
            chatStatus:"",
          }
          let temp_heart_change_distance = null;
          let temp_similarity = null;
          try{
            api.getEmpathyMatchingInfo(temp_params).then((res)=>{
                if(res.data != "fail" && res.data.data.empathy50){
                  if(res.data.data.empathy50<0.3){
                    let temp_similarity = 0.3*(0.7+res.data.data.empathy50);
                    temp_heart_change_distance = (1- temp_similarity)*50;
                  }else{
                    temp_heart_change_distance = (1- res.data.data.empathy50)*50;
                  }
                  temp_similarity = toPercent(res.data.data.empathy50) + "%";
                  i.heart_change_distance = temp_heart_change_distance;
                  i.similarity = temp_similarity;

                  // state.presenceInfoObj.waiting.sort();
                  if(state.chat_WaitingSortByTimeFlg){
                    // state.presenceInfoObj.waiting =   _.orderBy(state.presenceInfoObj.waiting,['startTime'],['desc']);
                    state.presenceInfoObj.waiting =  _.sortBy (state.presenceInfoObj.waiting, function(o) { return o.startTime}).reverse();
                  }else{
                    state.presenceInfoObj.waiting =   _.orderBy(state.presenceInfoObj.waiting,['similarity'],['desc']);
                  }

                  console.log("empathyinfo--->",state.presenceInfoObj.waiting)
                }else{
                  temp_similarity = '--%';
                  i.heart_change_distance = temp_heart_change_distance;
                  i.similarity = temp_similarity;
                  // state.presenceInfoObj.waiting.sort();
                  if(state.chat_WaitingSortByTimeFlg){
                    state.presenceInfoObj.waiting =  _.sortBy (state.presenceInfoObj.waiting, function(o) { return o.startTime}).reverse();
                  }else{
                    state.presenceInfoObj.waiting =   _.orderBy(state.presenceInfoObj.waiting,['similarity'],['desc']);
                  }
                  console.log("fail")
                }

              }),(err)=>{
                console.log("pi error", err);
              }
            }catch(err){
              console.log(err);
            }
        }

        // state.presenceInfoObj.waiting =   _.orderBy(state.presenceInfoObj.waiting,['similarity'],['desc']);

        function toPercent(point) {
          var str = Number(point * 100).toFixed(0)
          // str += "%";
          str = parseInt(str);
          // console.log(typeof (str))
          return str;
        }

        // state.manualChatUser =

        if(state.chat_current_status == "isWaiting"){
          let temp_user = _.find(state.presenceInfoObj.waiting,function(o){
            return o.id == state.manualChatCreateIssueUserId;
          })
          if(temp_user){
            state.manualButtonDisabled = false;
          }else{
            if(temp_user){
              if(temp_user.id == state.manualChatCreateIssueUserId){
                state.manualButtonDisabled = false;
              }else{
                state.manualButtonDisabled = true;
              }
            }else{
              state.manualButtonDisabled = true;
            }


          }
        }


        if(state.presenceInfoObj.waiting.length>0){



          for (let i of state.presenceInfoObj.waiting) {
            let temp = _.find(state.customerList, function (o) { return o.phonenum == i.id });//
            // i.logo_url = questioner_logo;
            if(temp){
              if(temp.logo_url){
                i.logo_url = temp.logo_url;
              }else{
                i.logo_url = questioner_logo;
              }
              // i.logo_url = temp.logo_url;
            }else{

              try{
                let params = {
                  phonenum:i.id
                }
                api.getCustomerInfoByNum(params).then((res)=>{
                  console.log(res);
                  if(res.data != 'fail'){
                    if(res.data.data[0].logo_url){
                      i.logo_url = res.data.data[0].logo_url;
                    }else{
                      i.logo_url = questioner_logo;
                    }
                  }

                },(err)=>{
                  console.log(err);
                })

              }catch(err){
                console.log(err);
              }


            }
            i.buttonStatus = "open";
            // if (state.manualChatUserList.indexOf(i.id) == -1) {

              // state.newUsernotificationFlg = "ok"
              context.commit(
                "changeNavigationText",
                state.html_const.cons_264_new_person_coming //アサイン待ちの新規チャットがあります。
              );
              if(!state.chatPiDiaLogVisible){
                state.isBlingFlg = true;
              }else{
                state.isBlingFlg = false;
              }

            // }
          }


        }else{
          context.commit(
            "changeNavigationText",
            ""
          );
        }

        // console.log("state.presenceInfoObj.waiting", state.presenceInfoObj.waiting)
        state.presenceInfoObj.ending = res.data.result.ending;
        if(state.presenceInfoObj.ending.length>0){
          for(let i of state.presenceInfoObj.ending){
            i['current_ending']= false;
            i["heart_change_distance"] = null;
            i["similarity"] = null;
              i.presence = "ending"
              let temp = _.find(state.customerList, function (o) { return o.phonenum == i.phone_number });
              if(temp){
                if(temp.logo_url){
                  i.logo_url = temp.logo_url;
                }else{
                  i.logo_url = questioner_logo;
                }
              }else{
                try{
                  let params = {
                    phonenum:i.phone_number
                  }
                  api.getCustomerInfoByNum(params).then((res)=>{
                    console.log(res);
                    if(res.data != 'fail'){
                      if(res.data.data[0].logo_url){
                        i.logo_url = res.data.data[0].logo_url;
                      }else{
                        i.logo_url = questioner_logo;
                      }
                    }

                  },(err)=>{
                    console.log(err);
                  })

                }catch(err){
                  console.log(err);
                }
                // i.logo_url = questioner_logo;
              }
          }
        }
        for(let i of state.presenceInfoObj.ending){
          let temp_params = {
            user_phoneNum:i.phone_number,
            // user_phoneNum:'01006',
            login_email:state.login_id,
            token:state.empathyMatChingToken,
            modeName: state.ws_mode,
            chatStatus:"",
          }
          let temp_heart_change_distance = null;
          let temp_similarity = null;
          try{
            api.getEmpathyMatchingInfo(temp_params).then((res)=>{
                if(res.data != "fail" && res.data.data.empathy50){
                  if(res.data.data.empathy50<0.3){
                    let temp_similarity = 0.3*(0.7+res.data.data.empathy50);
                    temp_heart_change_distance = (1- temp_similarity)*50;
                  }else{
                    temp_heart_change_distance = (1- res.data.data.empathy50)*50;
                  }
                  temp_similarity = toPercent(res.data.data.empathy50) + "%";
                  i.heart_change_distance = temp_heart_change_distance;
                  i.similarity = temp_similarity;
                  // state.presenceInfoObj.ending.sort();
                  if(state.chat_EndingSortByTimeFlg){
                    state.presenceInfoObj.ending =   _.orderBy(state.presenceInfoObj.ending,['chat_end_time'],['desc']);
                  }else{
                    // state.presenceInfoObj.ending =   _.orderBy(state.presenceInfoObj.ending,['similarity'],['desc']);
                    state.presenceInfoObj.ending =   _.orderBy(state.presenceInfoObj.ending,['chat_end_time'],['desc']);
                  }

                  console.log("empathyinfo--->",res)
                }else{
                  temp_similarity = '--%';
                  i.heart_change_distance = temp_heart_change_distance;
                  i.similarity = temp_similarity;
                  // state.presenceInfoObj.ending.sort();
                  if(state.chat_EndingSortByTimeFlg){
                    state.presenceInfoObj.ending =   _.orderBy(state.presenceInfoObj.ending,['chat_end_time'],['desc']);
                  }else{
                    // state.presenceInfoObj.ending =   _.orderBy(state.presenceInfoObj.ending,['similarity'],['desc']);
                    state.presenceInfoObj.ending =   _.orderBy(state.presenceInfoObj.ending,['chat_end_time'],['desc']);
                  }
                  console.log("fail")
                }

              }),(err)=>{
                console.log("pi error", err);
              }
            }catch(err){
              console.log(err);
            }
        }




        state.presenceInfoObj.chating_count = state.presenceInfoObj.chating.length;
        state.presenceInfoObj.waiting_count = state.presenceInfoObj.waiting.length;
        state.presenceInfoObj.ending_count = state.presenceInfoObj.ending.length;



      })
    }, (err) => {
      console.log('getAllCustomerName', err);
    })

    // console.log("params", params)

  },

  // 查询所有用户
  getAllUsers(context, item) {
    api.getAllUsers().then(res => {
      context.commit('changeUserList', res.data.data);
    })
  },

  async checkChatPresence(context, item) {
    let params = {
      userId: state.manualChatCreateIssueUserId,
      opId: state.user_id,
    }
    let res = await api.changeIssuePresence(params)
    return res
  },


  // manual chat create issue
  createManualChatIssue(context, item) {
    if (state.ws_mode === 'MANUAL_CHAT_MODE') {
      // console.log('manual chat createIssue start', moment().format('MMMM Do YYYY, hh:mm:ss'))

      let tempManualChatCreateIssueUserId = state.manualChatCreateIssueUserId;
      let params = {
        userId : state.user_id,
        status:"OnThePhone"
      }
      api.changePiStatus(params).then((res)=>{

        state.manualChatPiStatus = "OnThePhone";

    })

      context.dispatch("redmine/manualChatCreateIssue", {}, { root: true }).then(res => {
        // context.dispatch("getUC1IssueAllText");
        console.log("res", redmine.state.issue_id);
        state.manualChatModeIssueId = redmine.state.issue_id;
        state.chat_current_status = "isChating";

        store_sv.state.chat_current_customer_status = "iswaiting";
        let temp_sv = _.find(store_sv.state.chat_sv_helper_info_list,function (o) { return o.questioner_id == state.manualChatCreateIssueUserId});
        if(!temp_sv){
          store_sv.state.sv_help_onSupportFlg = false;
        }






        let tempTime = moment(state.issue_startTime)
        .utcOffset(0)
        .format("YYYY-MM-DD HH:mm:ss");
         let data = {
        userId: state.manualChatCreateIssueUserId,
        issueId:redmine.state.issue_id,
        manualChatStartTime: tempTime,
      };
      state.manualChatStartTimeList.push(data);

        // for(let i =0;i<=state.manualChatMessageList.length;i++){
        //   if(state.manualChatMessageList[i].isChatbot){
        //     state.manualChatMessageList[i].issueId = redmine.state.issue_id
        //   }
        // }
        //
        // state.manualChatCreateIssueUserId = "";


        for(let i of state.manualChatMessageList){
          // if(i.isChatbot==true && i.issueId==""){
          //   i.issueId = redmine.state.issue_id
          // }
          if(i.issueId==""){
            i.issueId = redmine.state.issue_id
          }

          console.log(i.issueId);

        }

        console.log(state.manualChatMessageList)


        // console.log('manual chat createIssue end', moment().format('MMMM Do YYYY, hh:mm:ss'))
        context.dispatch("redmine/updateChatbotIssueIdForManualChat", {}, { root: true });

      //   let params = {
      //     userId : state.user_id,
      //     status:"OnThePhone"
      //   }
      //   api.changePiStatus(params).then((res)=>{

      //     state.manualChatPiStatus = "OnThePhone";

      // })


        // state.manualChatPiStatus ="OnThePhone"
        context.dispatch("connectChatPiMessageSocket",{userId:tempManualChatCreateIssueUserId });
        // let userData = {
        //   userId:state.manualChatQuestionerId,
        //   issueId:redmine.state.issue_id

        // }
        // state.manualChatUserList.push(userData);
        state.manualChatUserCount++;
        let tempCount = state.currentUserCount+1;
        //
        if (state.manualChatUserCount >= tempCount) {
          state.manualButtonDisabled = true;
          // console.log("到达上限!!!!!");
        }
        // state.newUsernotificationFlg = "no"
        state.manualChatShowWaitingListFlg = false;
        context.commit(
          "changeNavigationText",
          " "
        );

        state.manualChatButtonStatus = 'close';
        state.manualChatQuestionerId = tempManualChatCreateIssueUserId;
        // context.dispatch("stt/sttStart");//
        state.isBlingFlg = false;
      }).catch(err => {
        // context.dispatch("stt/sttStart");
        console.log("createManualChatIssueErr", err)
      });
    }
  },


  // change chat status

  changeChatStatus(context, item){
    let params = {
      userId : state.user_id,
      status:"Online"
    }
    api.changePiStatus(params).then((res)=>{

      state.manualChatPiStatus = "Online";

  })
  },

  // close manual chat

  closeManualChat(context, item) {
    // chatPiStatusLockReconnect = true;
    // ChatPiMessageStatusLockReconnect = true;
    let params = {
      userId: state.manualChatQuestionerId,
      operatorId: state.user_id,
      type: "UC2",
      issueId:state.manualChatModeIssueId
    }
    api.closeManualChat(params).then((res) => {
      // console.log("closeManualChatRes", res);
      // context.dispatch("getManualChatCurrentTime").then((res)=>{
      //   console.log(res);
      //   context.dispatch("updateIssueForManualChat");
      // })
      state.manualChatShowWaitingListFlg = true;
      let temp_manualChatUserCount = state.manualChatUserCount-1;
      if(temp_manualChatUserCount>=0){
        state.manualChatUserCount--;
      }
      console.log(state.manualChatUserCount)
      if(state.manualChatUserCount==0){
        state.manualChatPiStatus = "Online";
      }
      // if (state.manualChatUserCount <= state.currentUserCount) {
      //   state.manualButtonDisabled = false;
      // }
      // let tempId = state.manualChatQuestionerId;
      // let tempIssueId = state.manualChatModeIssueId
      // _.remove(state.manualChatUserList, function (o) {
      //   return o == tempIssueId;
      // })

      // context.dispatch("updateIssueForManualChat");
      piMessageFlag = false;
      chatPiMessageWs.close();

      state.manualChatButtonStatus = "open";
      state.manualButtonDisabled = true;
      store_sv.state.sv_help_isBlingFlg = false;
      store_sv.state.sv_help_onSupportFlg = false; // end sv help
      store_sv.state.isSvTalkBlingFlg = false;
      //update issue one step
      // let params_issue = {
      //   chat_end_time:
      // }
    })
  },

  //change manual chat message status

  changeManualChatMessageStatus(context, item) {
    let params = {
      userId: state.manualChatQuestionerId,
      operatorId: state.user_id,
      status: state.manualMessageStatus,
    }
    // console.log("changeManualChatMessageStatus__Params", params)
    api.changeManualChatMessageStatus(params).then((res) => {
      // console.log("changeManualChatMessageStatus", res)
    }).catch(err => {
      console.log(err);
    })
  },


  //change manual chat message status
  changeManualChatMessageStatusWhenNotRead(context, item){
    let params = {
      userId: state.manualChatQuestionerId,
      operatorId: state.user_id,
      status: "changeUser",
    }
    api.changeManualChatMessageStatus(params).then((res) => {
      // notsend
      let params2 = {
        userId: state.manualChatQuestionerId,
        operatorId: state.user_id,
        status: "notSend",
      }
      api.changeManualChatMessageStatus(params2).then((res) => {
      }).catch(err => {
        console.log(err);
      })

    }).catch(err => {
      console.log(err);
    })
  },

  // manual chat send message
  manualChatSendMessage(context, item) {
    let params = {
      userId: state.manualChatQuestionerId,
      operatorId: state.user_id,
      message: item.message,
    }
    api.manualChatSendMessage(params).then((res) => {
      // console.log("manualChatSendMessage", res);

      let params = {
        userId: state.manualChatQuestionerId,
        operatorId: state.user_id,
        status: state.manualMessageStatus,
      }
      api.changeManualChatMessageStatus(params).then((res) => {
        // console.log("manualChatSendMessage_status", res)
      }).catch(err => {
        console.log(err);
      })
    }).catch(err => {
      console.log(err);
    })

  },


  manualChatSendHoldOnMessage(context, item) {
    let params = {
      userId: state.manualChatQuestionerId,
      operatorId: state.user_id,
      message: item.message,
      // type: "holdOnStart"
      type: item.type
    }
    // let tempType = item.type;
    api.manualChatSendHoldOnMessage(params).then((res) => {
      // console.log("manualChatSendMessage", res);

      // let params = {
      //   userId: state.manualChatQuestionerId,
      //   operatorId: state.user_id,
      //   status: state.manualMessageStatus,
      // }
      // api.changeManualChatMessageStatus(params).then((res) => {
      //   // console.log("manualChatSendMessage_status", res)
      //   // if(tempType == "holdOnStart"){
      //   //   state.holdOnStatus = true;
      //   // }else{
      //   //   state.holdOnStatus = false;
      //   // }

      // }).catch(err => {
      //   console.log(err);
      // })
    }).catch(err => {
      console.log(err);
    })
  },

  // manual chat update issue
  updateIssueForManualChat(context, item) {

    let tempTime = _.find(state.manualChatStartTimeList, function (o) {
      return (o.issueId == state.manualChatModeIssueId);
    });


    if(tempTime){
      let params = {
        chat_end_time: stt.state.sttEndTime,
        user_chat_time: tempTime.manualChatStartTime,
        issueId: state.manualChatModeIssueId
      }
      console.log(redmine.state.issue_id)
      api.updateIssueForManualChat(params).then((res) => {
        console.log(res);
      }).catch(err => {
        console.log(err);
      })
    }else{
      let params = {
        chat_end_time: stt.state.sttEndTime,
        user_chat_time: stt.state.sttEndTime,
        issueId: state.manualChatModeIssueId
      }
      console.log(redmine.state.issue_id)
      api.updateIssueForManualChat(params).then((res) => {
        console.log(res);
      }).catch(err => {
        console.log(err);
      })
    }


    // for (let i of state.presenceInfoObj.ending) {
    //   // issue_id
    //   if (state.manualChatModeIssueId === i.issue_id) {
    //     let params = {
    //       chat_end_time: i.chat_end_time,
    //       user_chat_time: i.user_chat_time,
    //       issueId: state.manualChatModeIssueId
    //     }
    //     // console.log(redmine.state.issue_id)
    //     api.updateIssueForManualChat(params).then((res) => {
    //       // console.log(res);
    //     }).catch(err => {
    //       console.log(err);
    //     })
    //   }
    // }


  },


  //manual chat input fetch-suggestions

  manualChatFetchSuggestions() {
    api.manualChatFetchSuggestions().then((res) => {
      state.autocompleteData = res.data.data.data;
      // console.log("state.autocompleteData", state.autocompleteData)
    }).catch(err => {
      console.log(err);
    })
  },


  // manual chat user count
  getCurrentUserCount(){
    api.getCurrentUserCount().then((res)=>{
      state.currentUserCount = res.data.data.value;
      console.log("state.CurrentUserCount",state.currentUserCount)
    }).catch(err=>{
      console.log(err);
    })
  },

  // ws close

  //chatPiWs close

  // chatPiWsClose(){
  //   chatPiWs.onclose = function (event) {
  //     console.log("chatPiWsClose event:", event);
  //     chatPiWs.close();
  //   };
  // },

  // chatPiMessageClose(){
  //   chatPiMessageWs.onclose = function (event) {
  //     console.log("chatPiMessageClose event:", event);
  //     chatPiMessageWs.close();
  //   };
  // },



  // getAllCustomerName
  fetchAllCustomerName(context, item) {
    api.getAllCustomerName().then((res) => {
      // console.log("getAllCustomerName", res.data.data)
      context.commit('changeAllCustomer', res.data.data);
    }, (err) => {
      console.log('getAllCustomerName', err);
    })
  },

  fetchHtmlConst(context, item) {
    api.getHtmlConst().then((res) => {
      context.commit('changeHtmlConst', res.data.data);
    }, (err) => {
      console.log('getHtmlConst', err);
    });
  },
  fetchSingleMode(context, item) {
    api.getSingleMode().then((res) => {
      const systemSingleMode = res.data.data.systemSingleMode;
      const personalEnable = res.data.data.personalEnable;
      context.commit('changeSysConfig', { systemSingleMode, personalEnable });

      let stt_mode = '';

      if (state.personalEnable == 0 && state.systemSingleMode) {
        if (state.systemSingleMode == mode.asterisk) {
          stt_mode = mode.asterisk;
        } else if (state.systemSingleMode == mode.converger) {
          stt_mode = mode.converger;
        } else if (state.systemSingleMode == mode.standMic) {
          stt_mode = mode.standMic;
        }
      } else if (state.personalEnable == 1 && state.personalSingleMode) {
        if (state.personalSingleMode == mode.asterisk) {
          stt_mode = mode.asterisk;
        } else if (state.personalSingleMode == mode.standMic) {
          stt_mode = mode.standMic;
        } else if (state.personalSingleMode == mode.manualChat) {
          stt_mode = mode.manualChat;
        }
      }

      state.ws_mode = stt_mode;
      // console.log('ws_mode', state.ws_mode);
      if (state.ws_mode === 'NEXMO_ASTERISK_PBX_MODE') {
        state.showPiButton = 'ok';
        // console.log("state.showPiButton", state.showPiButton)
      }
      if (state.ws_mode === 'MANUAL_CHAT_MODE') {
        state.showChatPiButton = 'ok';
         // changeChatStatus
        context.dispatch('changeChatStatus');
      }
      // getSttToken();
      const sipConfig={
        sip_domain:res.data.data.sip_domain,
        sip_wss_server:res.data.data.sip_wss_server,
        sip_pw:res.data.data.sip_pw,
        sip_websocket_port:res.data.data.sip_websocket_port,
        sip_server_path:res.data.data.sip_server_path,
      }
      context.commit('phone/setLongTimeWaiting', parseInt(Number(res.data.data.waitAbandoned)/1000),{root:true});
      context.commit('phone/updateCallStartAudioTime', Number(res.data.data.call_start_audio_time),{root:true});
      context.dispatch('getSttToken');
      context.dispatch('changerTurnMicStartTitle', stt_mode);
      // state.turnMicStart_title = state.sysInit.ws_mode === 'NEXMO_ASTERISK_PBX_MODE' ? (state.sysInit.talkStatus === 'start' ?'応対中 ':(state.sysInit.talkStatus=== ''?'待機中':'待機中')) : state.sysInit.html_const.cons_205_start;
      context.commit('changeNexmoWebsocketUri', res.data.data.nexmo_websocket_uri);
      context.commit('changeSipConfig', sipConfig);
      context.dispatch('connectStatusWs');
      context.dispatch('connectChatPiSocket');
      context.dispatch('connectPiWs');
      context.dispatch('connectF2FSvSocket');
    }, (err) => {
      console.log(err);
    });

    // window.onbeforeunload = function() {
    //   if(statusWs != null){
    //     statusWs.close();
    //   }
    // }
  },
  //changerTurnMicStartTitle
  changerTurnMicStartTitle(context, mode) {
    if (mode === 'NEXMO_ASTERISK_PBX_MODE') {

      if (state.talkStatus === '') {
        // 初始状态 - 灰色背景的【作業開始】
        state.turnMicStart_title = state.html_const.cons_205_start;
        state.ws_start_button = 'info'
        state.ws_mode = mode;
      } else if (state.talkStatus === 'ringing'){
        // 来电状态 - 蓝色背景的【作業開始】
        state.turnMicStart_title = state.html_const.cons_205_start;
        state.ws_start_button = 'primary'
        state.ws_mode = mode;
      } else if (state.talkStatus === 'start') {
        // 通话中状态 - 蓝色背景的【作業終了】
        // if (!state.modeFlag) {
        //   // state.turnMicStart_title = state.html_const.cons_259_responsing//応対中
        //   // state.ws_start_button = 'info'
        //   state.turnMicStart_title = state.html_const.cons_206_stop//
        //   state.ws_start_button = 'info'
        //   state.ws_mode = mode;
        //   state.modeFlag = true;
        // }
        state.turnMicStart_title = state.html_const.cons_206_stop//
        state.ws_start_button = 'primary'
        state.ws_mode = mode;
        state.modeFlag = true;
      } else if (state.talkStatus === 'end') {
        // 通话终了状态 - 蓝色背景的【起票】
        if (!state.modeFlag) {
          state.turnMicStart_title = state.html_const.cons_260_up_ticket//起票
          state.ws_start_button = 'primary'
          state.ws_mode = mode;
          state.call_error_finished = true;
        } else {
          state.turnMicStart_title = state.html_const.cons_260_up_ticket//起票
          state.ws_start_button = 'primary'
          state.ws_mode = mode;
          state.modeFlag = false;
        }


      }
      // state.ws_start_button = 'info'
    } else if (mode === 'STAND_MIC_MODE') {
      if (!stt.state.isMicOn) {
        state.turnMicStart_title = state.html_const.cons_205_start;
        state.ws_mode = mode;
        state.ws_start_button = 'primary';
        state.modeFlag = false
      } else {
        state.turnMicStart_title = state.html_const.cons_206_stop;
        state.ws_start_button = 'danger'
        state.ws_mode = mode;
      }

    } else if (mode === 'MANUAL_CHAT_MODE') {
      if (state.talkStatus === '') {
        state.turnMicStart_title = state.html_const.cons_205_start;
        state.ws_start_button = 'info'
        state.ws_mode = mode;
      } else if (state.talkStatus === 'start') {
        if (!state.modeFlag) {
          state.turnMicStart_title = state.html_const.cons_259_responsing//応対中
          state.ws_start_button = 'info'
          state.ws_mode = mode;
          state.modeFlag = true;
        }

      } else if (state.talkStatus === 'end') {
        if (!state.modeFlag) {
          state.turnMicStart_title = state.html_const.cons_205_start;
          state.ws_start_button = 'danger'
          state.ws_mode = mode;
        } else {
          state.turnMicStart_title = state.html_const.cons_260_up_ticket//起票
          state.ws_start_button = 'primary'
          state.ws_mode = mode;
          state.modeFlag = false;
        }


      }
    }
  },




  //
  changeShowImmediately(context, showImmediately) {
    let stt_mode = showImmediately ? 1 : 0;
    let params = {
      'stt_mode': stt_mode
    };
    api.updatePersonalConfig(params).then((res) => {
      context.commit('changeSysConfig', { showImmediately });
    }, (err) => {
      console.log(err);
    });
  },
  // updateNoiseCancelSpeech(context, noiseCancelSpeech) {
  //   console.log('updateNoiseCancelSpeech',noiseCancelSpeech)
  //   api.updatePersonalConfig({noise_cancel_speech:noiseCancelSpeech}).then((res) => {
  //     context.commit('changeSysConfig', {noiseCancelSpeech});
  //   }, (err) => {
  //     console.log(err);
  //   });
  // },
  // updateNoiseCancelBk(context, noiseCancelBk) {
  //   api.updatePersonalConfig({noise_cancel_bk:noiseCancelBk}).then((res) => {
  //     context.commit('changeSysConfig', {noiseCancelBk});
  //   }, (err) => {
  //     console.log(err);
  //   });
  // },
  fetchPersonalAndSingleModeConfig(context, item) {
    context.dispatch('fetchPersonalConfig');
  },
  fetchPersonalConfig(context, item) {
    let sysConfig = {};
    api.getPersonalConfig().then((perRes) => {
      // 用户角色
      if (perRes.data.data.person_config.role) {
        state.role = perRes.data.data.person_config.role;
      }
      sysConfig.keywordRate = perRes.data.data.person_config.map_display_rate;
      // sysConfig.personalSingleMode = perRes.data.data.person_config.personalSingleMode;
      sysConfig.personalSingleMode = perRes.data.data.person_config.single_mode;
      sysConfig.role = perRes.data.data.person_config.role
      // sysConfig.user_id =perRes.data.data.person_config.user_id;
      sysConfig.noiseCancelSpeech = perRes.data.data.noiseCancelSpeech;
      sysConfig.noiseCancelBk = perRes.data.data.noiseCancelBk;

      state.login_id = perRes.data.data.loginId;
      if (sysConfig.personalSingleMode === 'NEXMO_ASTERISK_PBX_MODE') {
        const modeFlag = true;
        context.commit('changeSysConfig', { modeFlag, modeFlag });
      }

      if (sysConfig.personalSingleMode === 'MANUAL_CHAT_MODE') {
        const modeFlag = true;
        context.commit('changeSysConfig', { modeFlag, modeFlag });
      }
      // console.log('state.modeFlag:', state.modeFlag);

      context.commit('changeUserId', perRes.data.data.person_config.user_id);
      context.commit('changeUserName', perRes.data.data.user_name);
      if(perRes.data.data.person_config.logo_url){
        state.operator_logo = perRes.data.data.person_config.logo_url;
        state.operator_logo_f2f = perRes.data.data.person_config.logo_url;
      }

      console.log(" state.operator_logo", state.operator_logo);
      context.commit('changeUserTelNum', perRes.data.data.person_config.tel_num);


      if (perRes.data.data.person_config.stt_mode == null) {
        api.getSysConfig().then((sysRes) => {
          sysConfig.showImmediately = sysRes.data.data.value == 1 ? true : false;
          context.commit('changeSysConfig', { ...sysConfig, ...perRes.data });
        }, (err) => {
          console.log(err);
        });
      } else {
        sysConfig.keywordRate = perRes.data.data.person_config.map_display_rate;
        sysConfig.showImmediately = perRes.data.data.person_config.stt_mode == 1 ? true : false;
        context.commit('changeSysConfig', { ...sysConfig, ...perRes.data });
      }
      context.dispatch('fetchSingleMode');

    }, (err) => {
      console.log(err);
    });
  },
  connectStatusWs(context, item) {
    let stt_mode = '';
    if (state.personalEnable && state.systemSingleMode) {
      if (state.personalEnable == 0 && state.systemSingleMode) {
        if (state.systemSingleMode == mode.asterisk) {
          stt_mode = mode.asterisk;
        } else if (state.systemSingleMode == mode.converger) {
          stt_mode = mode.converger;
        } else if (state.systemSingleMode == mode.standMic) {
          stt_mode = mode.standMic;
        }
      } else if (state.personalEnable == 1 && state.personalSingleMode) {
        if (state.personalSingleMode == mode.asterisk) {
          stt_mode = mode.asterisk;
        } else if (state.personalSingleMode == mode.standMic) {
          stt_mode = mode.standMic;
        } else if (state.personalSingleMode == mode.manualChat) {
          stt_mode = mode.manualChat;
        }
      }
      // console.log("stt_______mode", stt_mode);
      if (stt_mode == mode.asterisk && state.nexmo_websocket_uri && state.tel_num) {
        statusWsUrl = state.nexmo_websocket_uri + "status?sip=" + state.tel_num;
        // console.log('statusWsUrl:', statusWsUrl);
        createWebSocket(statusWsUrl);
      }
    }

    function createWebSocket(url) {
      try {
        if ('WebSocket' in window) {
          statusWs = new WebSocket(url);
        }
        initEventHandle();
      } catch (e) {
        reconnect(url);
        console.log("status websocket create err:", e);
      }
    }

    function initEventHandle() {
      statusWs.onclose = function (event) {
        reconnect(statusWsUrl);
        // console.log("status websocket close event:", event);
      };
      statusWs.onerror = function (err) {
        reconnect(statusWsUrl);
        // console.log("status websocket err:", err);
      };
      statusWs.onopen = function () {
        heartCheck.reset().start();
        // console.log("status websocket open.");
      };
      statusWs.onmessage = function (event) {
        heartCheck.reset().start();
        let msg = event.data;
        if (msg != 'pong') {
          // console.log('OP answering...');
          // state.op_answered = true;
          msg = JSON.parse(msg);

          console.log("msg---->",msg);
          if (msg.talkStatus === 'start') {
            context.commit('changeTalkStatus', msg.talkStatus)
            context.commit('changeWSIssueId', msg.issueId);

            if(msg.phoneNum){

              if(!state.phone_questioner_logo || !state.phone_questioner_name) {
                let params = {
                  phonenum : msg.phoneNum
                }

                console.log("start-------------------------->")
                api.getCustomerInfoByNum(params).then((res)=>{
                  console.log(res)
                  if(res.data != 'fail'){
                    if(res.data.data[0].firstname && res.data.data[0].lastname){
                      state.phone_questioner_name = vueUtils.computeFullName(res.data.data[0].lastname, res.data.data[0].firstname);

                      // 次のredmineのall text項目を更新する時、ユーザー名称を一括切り替え
                      state.toUpdateUserNameForRedmineHisFlg = true
                    }else{
                      state.phone_questioner_name = 'ゲスト';
                    }

                    if(res.data.data[0].logo_url){
                      state.phone_questioner_logo = res.data.data[0].logo_url;
                    }else{
                      state.phone_questioner_logo = questioner_logo;
                    }
                  }
                },(err)=>{
                  console.log(err)
                })
              }



            }

            if(msg.issueId && msg.phoneNum){
            let params = {
            phonenum:msg.phoneNum,
            issue_id:msg.issueId
          }

            return api.updateQuestionerAgeAndSexForPhone(params).then((res)=>{
              console.log(res)
            },(err)=>{
              console.log(err);
            })

            }
            // store_sv.state.phone_sv_help_status = "iscalled";
            // piAnalyze(msg.phoneNum);
            // context.commit('changePhoneNum',msg.phoneNum);
          } else if(msg.talkStatus === 'end') {
            store_sv.state.sv_help_isBlingFlg = false;
            store_sv.state.sv_help_phone_end=true,
            context.commit('changeTalkStatus', msg.talkStatus);
          }

          if(msg.svhelpStatus == "onSupport"){
            // store_sv.state.phone_sv_help_status = "iscalling";
            store_sv.state.sv_help_isBlingFlg = false;
            store_sv.state.sv_helper_info.svName = msg.svName;
            store_sv.state.sv_helper_info.svExtension = msg.svExtension;
            store_sv.state.sv_help_onSupportFlg = true;

          }

          if(msg.type === "svhelpReset"){
            store_sv.state.sv_help_isBlingFlg = false;
            store_sv.state.sv_help_onSupportFlg = false;
          }
          // context.dispatch("stt/turnMicStart");

        }
      };
    }



    function reconnect(url) {
      if (statusLockReconnect) return;
      statusLockReconnect = true;
      setTimeout(function () {
        createWebSocket(url);
        statusLockReconnect = false;
      }, 2000);
    }

    let heartCheck = {
      timeout: 1000,
      timeoutObj: null,
      serverTimeoutObj: null,
      reset: function () {
        clearTimeout(this.timeoutObj);
        clearTimeout(this.serverTimeoutObj);
        return this;
      },
      start: function () {
        let self = this;
        this.timeoutObj = setTimeout(function () {
          if (statusWs != null && statusWs.readyState == 1) {
            statusWs.send("ping");
          }
          self.serverTimeoutObj = setTimeout(function () {
            // if(statusWs != null && statusWs.readyState == 3){
            //   statusWs.close();
            // }
          }, self.timeout)
        }, this.timeout)
      }
    }

  },


  //pi web socket
  connectPiWs(context, item) {
    let stt_mode = '';
    if (state.personalEnable && state.systemSingleMode) {
      if (state.personalEnable == 0 && state.systemSingleMode) {
        if (state.systemSingleMode == mode.asterisk) {
          stt_mode = mode.asterisk;
        } else if (state.systemSingleMode == mode.converger) {
          stt_mode = mode.converger;
        } else if (state.systemSingleMode == mode.standMic) {
          stt_mode = mode.standMic;
        }
      } else if (state.personalEnable == 1 && state.personalSingleMode) {
        if (state.personalSingleMode == mode.asterisk) {
          stt_mode = mode.asterisk;
        } else if (state.personalSingleMode == mode.standMic) {
          stt_mode = mode.standMic;
        } else if (state.personalSingleMode == mode.manualChat) {
          stt_mode = mode.manualChat;
        }
      }
      // console.log("pi_stt_______mode", stt_mode);
      if (stt_mode == mode.asterisk && state.nexmo_websocket_uri && state.tel_num) {
        piWsUrl = state.nexmo_websocket_uri + "piCallInfo?sip=" + state.tel_num;
        console.log('piWsUrl:', piWsUrl);
        context.dispatch('fetchAllCustomerName');
        context.dispatch('getPiCallInfo');
        createWebSocket(piWsUrl);
      }
    };

    function createWebSocket(url) {
      try {
        if ('WebSocket' in window) {
          piWs = new WebSocket(url);
        }
        initEventHandle();
      } catch (e) {
        reconnect(url);
        // console.log(" pi websocket create err:", e);
      }
    };

    function initEventHandle() {
      piWs.onclose = function (event) {
        reconnect(piWsUrl);
        // console.log("pi websocket close event:", event);
      };

      piWs.onerror = function (err) {
        reconnect(piWsUrl);
        // console.log("pi websocket err:", err);
      };

      piWs.onopen = function () {
        heartCheck.reset().start();
        // console.log("pi websocket open.");
      };

      piWs.onmessage = function (event) {
        heartCheck.reset().start();
        let msg = event.data;
        if (msg != 'pong') {

          msg = JSON.parse(msg);
          console.log("msg------>",msg);
          state.piCallInfoObj_ws.pi_calling = msg.calling;
          state.piCallInfoObj_ws.pi_waiting = msg.waiting;

          // console.log('pi answering...', msg);
          // context.dispatch('testCallInfo');
          // context.dispatch('getPiCallInfo');
          // state.piCallWaitVisible = true;
          //  state.piRecordVisible = true;
        }
      };
    };

    function reconnect(url) {
      if (piStatusLockReconnect) return;
      piStatusLockReconnect = true;
      setTimeout(function () {
        createWebSocket(url);
        piStatusLockReconnect = false;
      }, 2000);
    };

    let heartCheck = {
      timeout: 1000,
      timeoutObj: null,
      serverTimeoutObj: null,
      reset: function () {
        clearTimeout(this.timeoutObj);
        clearTimeout(this.serverTimeoutObj);
        return this;
      },
      start: function () {
        let self = this;
        this.timeoutObj = setTimeout(function () {
          if (piWs != null && piWs.readyState == 1) {
            piWs.send("ping");
          }
          self.serverTimeoutObj = setTimeout(function () {
            // if(statusWs != null && statusWs.readyState == 3){
            //   statusWs.close();
            // }
          }, self.timeout)
        }, this.timeout)
      }
    }

  },


  //chat pi socket
  connectChatPiSocket(context, item) {
    let stt_mode = '';
    if (state.personalEnable && state.systemSingleMode) {
      if (state.personalEnable == 0 && state.systemSingleMode) {
        if (state.systemSingleMode == mode.asterisk) {
          stt_mode = mode.asterisk;
        } else if (state.systemSingleMode == mode.converger) {
          stt_mode = mode.converger;
        } else if (state.systemSingleMode == mode.standMic) {
          stt_mode = mode.standMic;
        }
      } else if (state.personalEnable == 1 && state.personalSingleMode) {
        if (state.personalSingleMode == mode.asterisk) {
          stt_mode = mode.asterisk;
        } else if (state.personalSingleMode == mode.standMic) {
          stt_mode = mode.standMic;
        } else if (state.personalSingleMode == mode.manualChat) {
          stt_mode = mode.manualChat;
        }
      }
      // console.log("chat_pi_stt_______mode", stt_mode);
      if (stt_mode == mode.manualChat && state.nexmo_websocket_uri && state.tel_num && state.user_id) {
        chatPiWsUrl = state.nexmo_websocket_uri + "chat/status?operatorId=" + state.user_id + "&type=UC2";
        console.log('chatPiWsUrl:', chatPiWsUrl);
        context.dispatch('fetchAllCustomerName');
        context.dispatch('getManualChatCurrentTime');
        createWebSocket(chatPiWsUrl);
      }
    };

    function createWebSocket(url) {
      try {
        if ('WebSocket' in window) {
          chatPiWs = new WebSocket(url);
        }
        initEventHandle();
      } catch (e) {
        reconnect(url);
        // console.log(" pi websocket create err:", e);
      }
    };
    function initEventHandle() {
      chatPiWs.onclose = function (event) {
        reconnect(chatPiWsUrl);
        // console.log("chat pi websocket close event:", event);
      };

      chatPiWs.onerror = function (err) {
        reconnect(chatPiWsUrl);
        // console.log("chat pi websocket err:", err);
      };

      chatPiWs.onopen = function () {
        heartCheck.reset().start();
        // console.log("chat pi websocket open.");
      };

      chatPiWs.onmessage = function (event) {
        heartCheck.reset().start();
        let msg = event.data;
        // console.log("piStatus:",msg)
        if (msg != 'pong') {


          msg = JSON.parse(msg);
          // console.log('chat pi answering...', msg);

          // if(msg.chating.length){
          //   state.presenceInfoObj.chating = msg.chating;
            for(let i of msg.chating){
              if(state.manualChatQuestionerId== i.id && i.presence === "waitClose" && i.issueId == state.manualChatModeIssueId){
               store_sv.state.chat_current_customer_status = "waitClose";
               _.remove(store_sv.state.chat_sv_helper_info_list,function(i){
                return i.questioner_id == state.manualChatQuestionerId;
              })

              _.remove(store_sv.state.svTalkMessageList,function(i){
                return i.questioner_id == state.manualChatQuestionerId && i.issueId == state.manualChatModeIssueId;
              })
                state.manualChatSendMessageFlg = false;
                state.manualChatShowWaitingListFlg = true;
                state.writingFlg = "false";
              //  state.manualButtonDisabled = true;
                //holdon
                if(state.holdOnUserList.indexOf(i.issueId) != -1){
                  let tempId = i.issueId;
                  _.remove(state.holdOnUserList,function(i){
                    return(i == tempId);
                  })
                }
                // if(state.manualChatUserList.indexOf(i.id) != -1 ){
                //   let tempId = i.id;
                //   _.remove(state.manualChatUserList,function(i){
                //     return(i == tempId);
                //   })
                // }
                state.waitCloseIssueId.push(i.issueId)
              }else{
                state.manualChatSendMessageFlg = true;
              }
            }
          // };


          if(msg.waiting.length){
            context.commit(
              "changeNavigationText",
              state.html_const.cons_264_new_person_coming //アサイン待ちの新規チャットがあります。
            );
            if(!state.chatPiDiaLogVisible){
              state.isBlingFlg = true;
            }else{
              state.isBlingFlg = false;
            }
          }
          // state.presenceInfoObj.chating_count =msg.chating.length;
          // state.presenceInfoObj.waiting_count = msg.waiting.length;




          context.dispatch('getManualChatCurrentTime');//////////


          // state.piCallWaitVisible = true;
          //  state.piRecordVisible = true;
        }
      };
    };

    function reconnect(url) {
      if (chatPiStatusLockReconnect) return;
      chatPiStatusLockReconnect = true;

      setTimeout(function () {
        createWebSocket(url);
        chatPiStatusLockReconnect = false;
      }, 2000);

    };
    let heartCheck = {
      timeout: 1000,
      timeoutObj: null,
      serverTimeoutObj: null,
      reset: function () {
        clearTimeout(this.timeoutObj);
        clearTimeout(this.serverTimeoutObj);
        return this;
      },
      start: function () {
        let self = this;
        this.timeoutObj = setTimeout(function () {
          if (chatPiWs != null && chatPiWs.readyState == 1) {
            // console.log("pistatus: ping")
            chatPiWs.send("ping");
          }
          self.serverTimeoutObj = setTimeout(function () {
            // if(statusWs != null && statusWs.readyState == 3){
            //   statusWs.close();
            // }
          }, self.timeout)
        }, this.timeout)
      }
    }

  },

  // chat pi message socket
  connectChatPiMessageSocket(context, item) {
    // console.log("chat pi message socket.................")
    let manualChatUserId = item.userId;
    let stt_mode = '';
    if (state.personalEnable && state.systemSingleMode) {
      if (state.personalEnable == 0 && state.systemSingleMode) {
        if (state.systemSingleMode == mode.asterisk) {
          stt_mode = mode.asterisk;
        } else if (state.systemSingleMode == mode.converger) {
          stt_mode = mode.converger;
        } else if (state.systemSingleMode == mode.standMic) {
          stt_mode = mode.standMic;
        }
      } else if (state.personalEnable == 1 && state.personalSingleMode) {
        if (state.personalSingleMode == mode.asterisk) {
          stt_mode = mode.asterisk;
        } else if (state.personalSingleMode == mode.standMic) {
          stt_mode = mode.standMic;
        } else if (state.personalSingleMode == mode.manualChat) {
          stt_mode = mode.manualChat;
        }
      }
      // console.log("chat_pi_message_______mode", stt_mode);
      state.manualChatModeIssueId = redmine.state.issue_id;
      // context.commit(' changeManualChatIssueId', msg.issueId);
      // console.log(" state.manualChatModeIssueId", state.manualChatModeIssueId);
      // console.log("")

      if (stt_mode == mode.manualChat && state.nexmo_websocket_uri && manualChatUserId && state.manualChatModeIssueId && state.user_id) {
        chatPiMessageWsUrl = state.nexmo_websocket_uri + "chat/message?userId=" + manualChatUserId + "&operatorId=" + state.user_id + "&type=UC2" + "&issueId=" + state.manualChatModeIssueId;
        state.mqseqList = [];
        console.log('chatPiMessageWsUrl:', chatPiMessageWsUrl);
        createWebSocket(chatPiMessageWsUrl);
      }
    };

    function createWebSocket(url) {
      try {
        if ('WebSocket' in window) {
          chatPiMessageWs = new WebSocket(url);
        }
        initEventHandle();
      } catch (e) {
        reconnect(url);
        // console.log(" pi websocket message create err:", e);
      }
    };

    function initEventHandle() {
      chatPiMessageWs.onclose = function (event) {
        reconnect(chatPiMessageWsUrl);
        console.log("chat pi  message websocket close event:", event);
      };

      chatPiMessageWs.onerror = function (err) {
        reconnect(chatPiMessageWsUrl);
        console.log("chat pi  message websocket err:", err);
      };

      chatPiMessageWs.onopen = function () {
        heartCheck.reset().start();
        console.log("chat pi  message websocket open.");
      };

      chatPiMessageWs.onmessage = function (event) {
        heartCheck.reset().start();
        let msg = event.data;

        // console.log("piMessage : ", msg)

        if (msg != 'pong') {
          console.log('chat pi message answering...', msg);

          let msg1 = JSON.parse(msg);

          if (msg1.type === "close") {
            piMessageFlag = false;
            let mqseq = JSON.parse(event.data).mqseq;
            if (state.mqseqList.length > 0 && state.mqseqList.indexOf(mqseq) > -1) {
              return;
            } else {
              state.mqseqList.push(mqseq);
            }
            let receiveJson = {
              type: 'received',
              mqseq: mqseq
            };
            chatPiMessageWs.send(JSON.stringify(receiveJson));
            if (!msg1.logo) {
              msg1.logo = questioner_logo
            }
            state.writingFlg = "false";
            state.manualChatSendMessageFlg = false;//
            // state.manualButtonDisabled = true;//
            chatPiMessageWs.close();
          }

          if (msg1.type === "serviceLongTime") {
            let mqseq = JSON.parse(event.data).mqseq;
            if (state.mqseqList.length > 0 && state.mqseqList.indexOf(mqseq) > -1) {
              return;
            } else {
              state.mqseqList.push(mqseq);
            }
            let receiveJson = {
              type: 'received',
              mqseq: mqseq
            };
            chatPiMessageWs.send(JSON.stringify(receiveJson));
            if (!msg1.logo) {
              msg1.logo = questioner_logo
            }
            let data = {
              id: state.messageId++,
              flag: "left",
              userId: msg1.userId,
              text: state.html_const.cons_268_operator_end_message,
              checked: false,
              user: state.html_const.cons_266_moppy_name,
              messageTime: msg1.time,
              status: false,
              checkBoxFlg:false,
              issueId:msg1.issueId,
              isChatbot:false,
              username:state.html_const.cons_266_moppy_name,
              // chatbotIssueId:state.manualChatbotIssueId

            }
            state.manualChatMessageList.push(data);
          }

          if(msg1.type === "autoClose"){
            piMessageFlag = false;
            let mqseq = JSON.parse(event.data).mqseq;
            if (state.mqseqList.length > 0 && state.mqseqList.indexOf(mqseq) > -1) {
              return;
            } else {
              state.mqseqList.push(mqseq);
            }
            let receiveJson = {
              type: 'received',
              mqseq: mqseq
            };
            chatPiMessageWs.send(JSON.stringify(receiveJson));
            if (!msg1.logo) {
              msg1.logo = questioner_logo
            }
            state.writingFlg = "false";
            state.manualChatSendMessageFlg = false;//
            let data = {
              id: state.messageId++,
              flag: "left",
              userId: msg1.userId,
              text: state.html_const.cons_269_operator_end_automatically,
              checked: false,
              user: state.html_const.cons_266_moppy_name,
              messageTime: msg1.time,
              status: false,
              checkBoxFlg:false,
              issueId:msg1.issueId,
              isChatbot:false,
              username:state.html_const.cons_266_moppy_name,
              // chatbotIssueId:state.manualChatbotIssueId

            }
            state.manualChatMessageList.push(data);
            // state.manualButtonDisabled = true;//
            chatPiMessageWs.close();
          }


          if (msg1.type === "isWriting") {
            state.writingFlg = "true";
          } else {
            if (msg1.message && msg1.role ==="customer") {
              let mqseq = JSON.parse(event.data).mqseq;
              if (state.mqseqList.length > 0 && state.mqseqList.indexOf(mqseq) > -1) {
                return;
              } else {
                state.mqseqList.push(mqseq);
              }
              let receiveJson = {
                type: 'received',
                mqseq: mqseq
              };
              chatPiMessageWs.send(JSON.stringify(receiveJson));
              if(!msg1.logo){
                msg1.logo = questioner_logo
              }
              state.writingFlg = "false";
              let data = {
                id: state.messageId++,
                flag: "right",
                userId: msg1.userId,
                text: msg1.message,
                checked: false,
                user: state.html_const.cons_217_questioner,
                messageTime: moment(msg1.time)
                  .utcOffset(0)
                  .format("YYYY-MM-DD HH:mm:ss"),
                status: false,
                checkBoxFlg:false,
                issueId:msg1.issueId,
                isChatbot:false,
                username:msg1.name,
                logo_url:msg1.logo
                // chatbotIssueId:state.manualChatbotIssueId
              }
              state.manualChatMessageList.push(data);


              context.dispatch("redmine/manualChatMessageRecord", {}, { root: true });

              let item = {
                flag: data.flag,
                text: data.text,
                mode: state.ws_mode
              }

              context.dispatch("stt/fetchKeywordByDialogRight", {
                ...item,
                request_id: redmine.state.issue_id,
                keywordRate: state.keywordRate
              }, { root: true });

              // console.log('state.manualChatMessageList', state.manualChatMessageList);
            }


          }


          if( msg1.type !="innerMessage" && msg1.role ===  "supervisor"){
            let mqseq = JSON.parse(event.data).mqseq;
            if (state.mqseqList.length > 0 && state.mqseqList.indexOf(mqseq) > -1) {
              return;
            } else {
              state.mqseqList.push(mqseq);
            }
            let receiveJson = {
              type: 'received',
              mqseq: mqseq
            };
            chatPiMessageWs.send(JSON.stringify(receiveJson));
            if(!msg1.logo){
              msg1.logo = questioner_logo
            }
            let data = {
              id: state.messageId++,
              flag: "left",
              userId:msg1.userId,
              text: msg1.message,
              checked: false,
              user: msg1.name,
              messageTime: moment(msg1.time)
                .utcOffset(0)
                .format("YYYY-MM-DD HH:mm:ss"),
              status: false,
              checkBoxFlg:false,
              issueId:msg1.issueId,
              isChatbot:false,
              username:msg1.name,
              logo_url:msg1.logo,
              role:msg1.role
              // chatbotIssueId:state.manualChatbotIssueId
            }
            state.manualChatMessageList.push(data);
            context.dispatch("redmine/manualChatMessageRecord", {}, { root: true });

            // let item = {
            //   flag: data.flag,
            //   text: data.text,
            //   mode: state.ws_mode
            // }

            // context.dispatch("stt/fetchKeywordByDialog", {
            //   ...item,
            //   request_id: redmine.state.issue_id,
            //   keywordRate: state.keywordRate
            // }, { root: true });

          }


          if(msg1.type === "svhelp"){

            let data_sv = {
              questioner_id : msg1.customerId,
              svName : msg1.svName,
              svExtension : msg1.svExtension,
            }
            _.remove(store_sv.state.sv_help_isBlingFlg_list,function(i){
              return i.questioner_id == msg1.customerId;
            })
            store_sv.state.chat_sv_helper_info_list.push(data_sv);
            console.log(store_sv.state.chat_sv_helper_info_list);
            let temp_sv = _.find(store_sv.state.chat_sv_helper_info_list,function (o) { return o.questioner_id == state.manualChatQuestionerId});
            console.log(temp_sv);
            if(temp_sv){
              store_sv.state.chat_sv_name = temp_sv.svName;
            }
            store_sv.state.sv_help_isBlingFlg = false;
            store_sv.state.sv_help_onSupportFlg = true;
          }

          if(msg1.type === "svhelpReset"){
            console.log('=========1========', JSON.stringify(store_sv.state.sv_help_isBlingFlg_list));
            _.remove(store_sv.state.sv_help_isBlingFlg_list,function(i){
              return i.questioner_id == msg1.customerId;
            })
            console.log('=========2========', JSON.stringify(store_sv.state.sv_help_isBlingFlg_list));

            console.log('=========3========', JSON.stringify(store_sv.state.chat_sv_helper_info_list));
            console.log('state.manualChatQuestionerId',state.manualChatQuestionerId)
            _.remove(store_sv.state.sv_help_isBlingFlg_list,function(i){
              return i.questioner_id == msg1.customerId;
            })
            console.log('=========4========', JSON.stringify(store_sv.state.chat_sv_helper_info_list));

            store_sv.state.sv_help_isBlingFlg = false;
            store_sv.state.sv_help_onSupportFlg = false;
          }


          if(msg1.type ==="innerMessage" && msg1.role ===  "supervisor"){

            if(!store_sv.state.svTalkDiaLogVisible){
              store_sv.state.isSvTalkBlingFlg = true;
            }

            let mqseq = JSON.parse(event.data).mqseq;
            if (state.mqseqList.length > 0 && state.mqseqList.indexOf(mqseq) > -1) {
              return;
            } else {
              state.mqseqList.push(mqseq);
            }
            let receiveJson = {
              type: 'received',
              mqseq: mqseq
            };
            chatPiMessageWs.send(JSON.stringify(receiveJson));
            let data_sv = {
              id:store_sv.state.svTalkMessageList_key++,
              flag: "right",
              questioner_id : msg1.userId,
              issueId : msg1.issueId,
              svName :msg1.name,
              sv_logo:msg1.logo,
              messageTime:moment(msg1.time)
              .utcOffset(0)
              .format("YYYY-MM-DD HH:mm:ss"),
              message:msg1.message,
              userName:msg1.name,
            }

            store_sv.state.svTalkMessageList.push(data_sv);

          }

          // context.dispatch('testCallInfo');
          // context.dispatch('getManualChatCurrentTime');
          // state.piCallWaitVisible = true;
          //  state.piRecordVisible = true;
        } else {
          console.log("pong")
          // console.log(chatPiMessageWsUrl)
        }
      };
    };

    function reconnect(url) {
      if (ChatPiMessageStatusLockReconnect) return;
      ChatPiMessageStatusLockReconnect = true;
      // console.log("piMessageFlag", piMessageFlag);
      if (piMessageFlag) {
        setTimeout(function () {
          createWebSocket(url);
          ChatPiMessageStatusLockReconnect = false;
        }, 2000);
      }
    };
    let heartCheck = {
      timeout: 1000,
      timeoutObj: null,
      serverTimeoutObj: null,
      reset: function () {
        clearTimeout(this.timeoutObj);
        clearTimeout(this.serverTimeoutObj);
        return this;
      },
      start: function () {
        let self = this;
        this.timeoutObj = setTimeout(function () {
          if (chatPiMessageWs != null && chatPiMessageWs.readyState == 1) {
            // console.log("piMessage : ping")
            chatPiMessageWs.send("ping");
          }
          self.serverTimeoutObj = setTimeout(function () {
            // if(statusWs != null && statusWs.readyState == 3){
            //   statusWs.close();
            // }
          }, self.timeout)
        }, this.timeout)
      }
    }


  },

  connectF2FSvSocket(context,item){
    let stt_mode = '';
    if (state.personalEnable && state.systemSingleMode) {
      if (state.personalEnable == 0 && state.systemSingleMode) {
        if (state.systemSingleMode == mode.asterisk) {
          stt_mode = mode.asterisk;
        } else if (state.systemSingleMode == mode.converger) {
          stt_mode = mode.converger;
        } else if (state.systemSingleMode == mode.standMic) {
          stt_mode = mode.standMic;
        }
      } else if (state.personalEnable == 1 && state.personalSingleMode) {
        if (state.personalSingleMode == mode.asterisk) {
          stt_mode = mode.asterisk;
        } else if (state.personalSingleMode == mode.standMic) {
          stt_mode = mode.standMic;
        } else if (state.personalSingleMode == mode.manualChat) {
          stt_mode = mode.manualChat;
        }
      }
      // console.log("stt_______mode", stt_mode);
      if (stt_mode == mode.standMic && state.nexmo_websocket_uri && state.user_id) {
        F2FSvWsUrl = state.nexmo_websocket_uri + "svhelp/F2Fstatus?operatorId="+state.user_id;
        console.log('F2FSvWsUrl:', F2FSvWsUrl);
        createWebSocket(F2FSvWsUrl);
      }
    }

    function createWebSocket(url) {
      try {
        if ('WebSocket' in window) {
          F2FSvWs = new WebSocket(url);
        }
        initEventHandle();
      } catch (e) {
        reconnect(url);
        console.log("status websocket create err:", e);
      }
    }
    function initEventHandle() {
      F2FSvWs.onclose = function (event) {
        reconnect(F2FSvWsUrl);
        // console.log("status websocket close event:", event);
      };
      F2FSvWs.onerror = function (err) {
        reconnect(F2FSvWsUrl);
        // console.log("status websocket err:", err);
      };
      F2FSvWs.onopen = function () {
        heartCheck.reset().start();
        // console.log("status websocket open.");
      };
      F2FSvWs.onmessage = function (event) {
        heartCheck.reset().start();
        let msg = event.data;
        if (msg != 'pong') {
          // console.log('OP answering...');
          // state.op_answered = true;
          msg = JSON.parse(msg);

          console.log("msg---->",msg);


          if(msg.svhelpStatus == "onSupport"){
            store_sv.state.sv_help_isBlingFlg = false;
            store_sv.state.sv_helper_info.svName = msg.svName;
            store_sv.state.sv_helper_info.svExtension = msg.svExtension;
            store_sv.state.sv_help_onSupportFlg = true;

          }
          if(msg.type === "svhelpReset"){
            store_sv.state.sv_help_isBlingFlg = false;
            store_sv.state.sv_help_onSupportFlg = false;
          }
        }
      };
    }

    function reconnect(url) {
      if (F2FSvStatusLockReconnect) return;
      F2FSvStatusLockReconnect = true;
      setTimeout(function () {
        createWebSocket(url);
        F2FSvStatusLockReconnect = false;
      }, 2000);
    }

    let heartCheck = {
      timeout: 1000,
      timeoutObj: null,
      serverTimeoutObj: null,
      reset: function () {
        clearTimeout(this.timeoutObj);
        clearTimeout(this.serverTimeoutObj);
        return this;
      },
      start: function () {
        let self = this;
        this.timeoutObj = setTimeout(function () {
          if (F2FSvWs != null && F2FSvWs.readyState == 1) {
            F2FSvWs.send("ping");
          }
          self.serverTimeoutObj = setTimeout(function () {
            // if(statusWs != null && statusWs.readyState == 3){
            //   statusWs.close();
            // }
          }, self.timeout)
        }, this.timeout)
      }
    }
  },

  //getUC1IssueAllText

  getUC1IssueAllText(context, item) {
console.log("item:",item)
    let val = item;
    // console.log(eval("val."+"id"));
    console.log(val.val.id);
    let temp_logo_url = "";
    let temp = _.find(state.customerList, function (o) { return o.phonenum == val.val.id });//
    if(temp){
      temp_logo_url = temp.logo_url;
    }else{
      try{
        let params = {
          phonenum:val.val.id
        }
        api.getCustomerInfoByNum(params).then((res)=>{
          console.log(res);
          if(res.data != 'fail'){
            if(res.data.data[0].logo_url){
              temp_logo_url= res.data.data[0].logo_url;
            }else{
              temp_logo_url= questioner_logo;
            }
          }

        },(err)=>{
          console.log(err);
        })

      }catch(err){
        console.log(err);
      }
    }
    state.manualButtonDisabled = true;
    state.searchDetail_issue_category = "";
    state.searchDetail_issue_tracker = "";
    state.manualChatbotAllTextList = [];
    state.manualChatbotCategoryTag = [];
    if (state.chatBotUserIdList.indexOf(val.val.id) == -1) {
      let params = {
        userId: val.val.id
      };
      api.getUC1IssueAllText(params).then((res) => {
        if(res.data.data){
          state.manualButtonDisabled = false;
          state.manualChatbotIssueId = res.data.data.chatbotIssueId;
          state.manualChatbotAllTextList = res.data.data.sendList;
          state.manualChatbotCommentText = res.data.data.commentText;
          let temp_name  = state.html_const.cons_217_questioner;
          let temp_system_name = state.html_const.cons_266_moppy_name;//もっぴー
          state.searchDetail_issue_category = res.data.data.category_name ? res.data.data.category_name : "";
          state.searchDetail_issue_tracker = res.data.data.tracker_name? res.data.data.tracker_name : "";
          let temp_categoryList = []; 
          if(res.data.data.chatbotCategoryTag){
            temp_categoryList = res.data.data.chatbotCategoryTag.split(/\s+/g);
          }
          let temp_categoryList2 = [];
          for(let i of temp_categoryList){
            if(i){
              temp_categoryList2.push(i);
            }
          }
          state.manualChatbotCategoryTag = temp_categoryList2;

          let allText = res.data.data.sendList;
          if(state.manualChatbotAllTextList.length > 0){
            for(let i of state.manualChatbotAllTextList){
                if(res.data.data.username!=""){
                  if(i.user == "user" && i.flag =='right'){
                    i.username = res.data.data.username;
                  }
                }

                if(i.user == "system" && i.flag =='left'){
                  i.username =  state.html_const.cons_266_moppy_name;//もっぴー
                }
                let temp = _.find(state.customerList, function (o) { return o.phonenum == val.val.id });//
              if(temp){
                if(temp.logo_url){
                  i.logo_url = temp.logo_url;
                }else{
                  i.logo_url = questioner_logo;
                }
              }else{
                i.logo_url = temp_logo_url;
              }
            }
          }

          console.log("allText",allText)
          state.manualChatbotShowFlg = false;
          state.piChatbotVisible = false;
          // console.log(allText);
          // del br
          if (allText.length > 0) {
            for(let i of allText){
              if(res.data.data.username!=""){
                if(i.user == "user" && i.flag =='right'){
                  // i.user = res.data.data.username;
                  temp_name = res.data.data.username;
                }
              }
              if(i.user == "system" && i.flag =='left'){
                // i.user = 'もっぴー';
                temp_system_name =  state.html_const.cons_266_moppy_name;//もっぴー
              }
              let temp = i.text;
              let newText = "";
              i.text = temp.replace("<br>","");
              if(i.text.indexOf("<br>") != -1){
                let arr = i.text.split("<br>");
                arr.pop();
                newText = arr.join("<br>")
                i.text = newText.replace("<br><br>","<br>");
              }
            }
          }


          console.log(allText);
          if (allText.length > 0) {
            for (let i of allText) {
              if (i.flag == "right") {
                let data = {
                  id: state.messageId++,
                  flag: "right",
                  userId:  val.val.id,
                  text: i.text,
                  checked: false,
                  user: i.user,
                  messageTime: i.messageTime,
                  checkBoxFlg:false,
                  issueId:"",
                  isChatbot:true,
                  status: false,
                  username:temp_name,
                  logo_url:i.logo_url
                  // chatbotIssueId:state.manualChatbotIssueId
                }
                state.manualChatMessageList.push(data);
              };
              if (i.flag == "left") {
                let data = {
                  id: state.messageId++,
                  flag: "left",
                  userId:  val.val.id,
                  text: i.text,
                  checked: false,
                  user: i.user,
                  messageTime: i.messageTime,
                  checkBoxFlg:false,
                  issueId:"",
                  isChatbot:true,
                  status: false,
                  username:temp_system_name,
                  // chatbotIssueId:state.manualChatbotIssueId
                }
                state.manualChatMessageList.push(data);
              }
            }
          }
          console.log(state.manualChatMessageList);
          console.log(val);
          // console.log(Object.values(val)[0].id)
          // console.log(val.id);
          // console.log(val["id"]);
          let tempList = Object.values(val)[0].notReadList;
          console.log(tempList)
          if (tempList){
            for (let i = 0; i < tempList.length; i++) {
              let data = {
                id: state.messageId++,
                flag: "right",
                userId:  val.val.id,
                text: tempList[i].message,
                checked: false,
                user: state.html_const.cons_217_questioner,
                messageTime: moment().tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm:ss"),
                checkBoxFlg:false,
                issueId:"",
                isChatbot:false,
                status: false,
                username:temp_name,
                logo_url:temp_logo_url
                // chatbotIssueId:state.manualChatbotIssueId
              };
              state.manualChatMessageList.push(data);

              context.dispatch(
                "redmine/manualChatMessageRecord",
                {},
                { root: true }
              );
            }
          }

          // let item = {
          //   flag: data.flag,
          //   text: data.text,
          //   mode: state.ws_mode,
          // };

          // context.dispatch("stt/fetchKeywordByDialog", {
          //   ...item,
          //   request_id: redmine.state.issue_id,
          //   keywordRate: state.keywordRate
          // },

        }else{
          state.manualChatbotShowFlg = true;

        }

      }), (err) => {
        console.log(err);
      };
    }else{
      let tempId = val.val.id;
      _.remove(state.manualChatMessageList, function (i) {
        return i.userId == tempId && i.issueId == "";
      });
      let params = {
        userId: val.val.id
      };
      api.getUC1IssueAllText(params).then((res) => {
        if(res.data.data){
          state.manualButtonDisabled = false;
          let temp_name  = state.html_const.cons_217_questioner;
          let temp_system_name =  state.html_const.cons_266_moppy_name;//もっぴー
          state.manualChatbotIssueId = res.data.data.chatbotIssueId;
          state.manualChatbotAllTextList = res.data.data.sendList;
          state.manualChatbotCommentText = res.data.data.commentText;
          state.searchDetail_issue_category = res.data.data.category_name ? res.data.data.category_name : "";
          state.searchDetail_issue_tracker = res.data.data.tracker_name? res.data.data.tracker_name : "";
          if(state.manualChatbotAllTextList.length > 0){
            for(let i of state.manualChatbotAllTextList){
              if(i.flag =='right'){
                let temp = _.find(state.customerList, function (o) { return o.phonenum == val.val.id });//
                if(temp){
                  if(temp.logo_url){
                    i.logo_url = temp.logo_url;
                  }else{
                    i.logo_url = questioner_logo;
                  }
                }else{
                  i.logo_url = temp_logo_url;

                }
              }
                if(res.data.data.username!=""){
                  if(i.user == "user" && i.flag =='right'){
                    i.username = res.data.data.username;
                  }
                }

                if(i.user == "system" && i.flag =='left'){
                  i.username =  state.html_const.cons_266_moppy_name;//もっぴー
                }
            }
          }
          let allText = res.data.data.sendList;
          console.log("allText",allText)
          let temp_categoryList = []; 
          if(res.data.data.chatbotCategoryTag){
            temp_categoryList = res.data.data.chatbotCategoryTag.split(/\s+/g);
          }
          let temp_categoryList2 = [];
          for(let i of temp_categoryList){
            if(i){
              temp_categoryList2.push(i);
            }
          }
          state.manualChatbotCategoryTag = temp_categoryList2;

          state.manualChatbotShowFlg = false;
          state.piChatbotVisible = false;
          console.log(allText);
           // del br
           if (allText.length > 0) {
            for(let i of allText){
              if(res.data.data.username!=""){
                if(i.user == "user" && i.flag =='right'){
                  // i.user = res.data.data.username;
                  temp_name = res.data.data.username;
                }
              }
              if(i.user == "system" && i.flag =='left'){
                // i.user = 'もっぴー';
                  temp_system_name =  state.html_const.cons_266_moppy_name;//もっぴー
              }
              let temp = i.text;
              let newText = "";
              i.text = temp.replace("<br>","");
              if(i.text.indexOf("<br>") != -1){
                let arr = i.text.split("<br>");
                arr.pop();
                newText = arr.join("<br>")
                i.text = newText.replace("<br><br>","<br>");
              }
            }
          }
          if (allText.length > 0) {
            for (let i of allText) {
              if (i.flag == "right") {
                let data = {
                  id: state.messageId++,
                  flag: "right",
                  userId:  val.val.id,
                  text: i.text,
                  checked: false,
                  user: i.user,
                  messageTime: i.messageTime,
                  checkBoxFlg:false,
                  issueId:"",
                  isChatbot:true,
                  status: false,
                  username:temp_name,
                  logo_url:i.logo_url

                  // chatbotIssueId:state.manualChatbotIssueId
                }
                state.manualChatMessageList.push(data);
              };
              if (i.flag == "left") {
                let data = {
                  id: state.messageId++,
                  flag: "left",
                  userId:  val.val.id,
                  text: i.text,
                  checked: false,
                  user: i.user,
                  messageTime: i.messageTime,
                  checkBoxFlg:false,
                  issueId:"",
                  isChatbot:true,
                  status: false,
                  username:temp_system_name,
                  // chatbotIssueId:state.manualChatbotIssueId
                }
                state.manualChatMessageList.push(data);
              }
            }
          }
          console.log(val);
          // console.log(Object.values(val)[0].id)
          // console.log(val.id);
          // console.log(val["id"]);
          let tempList = Object.values(val)[0].notReadList;
          console.log(tempList)
          if(tempList){
            for (let i = 0; i < tempList.length; i++) {
              let data = {
                id: state.messageId++,
                flag: "right",
                userId:  val.val.id,
                text: tempList[i].message,
                checked: false,
                user: state.html_const.cons_217_questioner,
                messageTime: moment().tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm:ss"),
                checkBoxFlg:false,
                issueId:"",
                isChatbot:false,
                status: false,
                username:temp_name,
                logo_url:temp_logo_url
                // chatbotIssueId:state.manualChatbotIssueId
              };
              state.manualChatMessageList.push(data);

              context.dispatch(
                "redmine/manualChatMessageRecord",
                {},
                { root: true }
              );
            }
          }

        // state.uc1AllTextList = res.data;


          // let item = {
          //   flag: data.flag,
          //   text: data.text,
          //   mode: state.ws_mode,
          // };

          // context.dispatch("stt/fetchKeywordByDialog", {
          //   ...item,
          //   request_id: redmine.state.issue_id,
          //   keywordRate: state.keywordRate
          // }, { root: true });
        }else{
          state.manualChatbotShowFlg = true;
        }

      }), (err) => {
        console.log(err);
      };


    }
    state.chatBotUserIdList.push(val.val.id)


    console.log("state.manualChatMessageList", state.manualChatMessageList)
  },

  getchatbotAllText(context, item){
    state.piIssuesVisible = true;
    let val = item;
    let params = {
      issueId: val.val.issue_id?val.val.issue_id:val.val.issueId
    };

    let temp_phoneNumer = val.val.phone_number ? val.val.phone_number : val.val.id
    state.searchDetail_issue_category = "";
    state.searchDetail_issue_tracker = "";
    state.manualChatbotAllTextList = [];
    state.manualChatbotCategoryTag = [];
    api.getChatbotIssueByChatIssueId(params).then(async (res) => {
      if(res.data.data){
        state.manualChatbotIssueId = res.data.data.chatbotIssueId;
        state.manualChatbotAllTextList = res.data.data.sendList;
        state.manualChatbotCommentText = res.data.data.commentText;
        let temp_categoryList = [];
        if(res.data.data.chatbotCategoryTag){
          temp_categoryList = res.data.data.chatbotCategoryTag.split(/\s+/g);
        }
        let temp_categoryList2 = [];
        for(let i of temp_categoryList){
          if(i){
            temp_categoryList2.push(i);
          }
        }
        state.manualChatbotCategoryTag = temp_categoryList2;

        state.searchDetail_issue_category = res.data.data.category_name ? res.data.data.category_name : "";
        state.searchDetail_issue_tracker = res.data.data.tracker_name? res.data.data.tracker_name : "";

        let allText = res.data.data.sendList;
        for(let i of state.manualChatbotAllTextList){
            if(state.manualChatbotAllTextList.length > 0){
            if(i.flag =='right'){
              let temp = _.find(state.customerList, function (o) { return o.customer_id == val.val.id });//
              if(temp){
                if(temp.logo_url){
                  i.logo_url = temp.logo_url;
                }else{
                  i.logo_url = questioner_logo;
                }
              }else{
                try{
                  let params = {
                    phonenum:val.val.id
                  }

                  let _res = await api.getCustomerInfoByNum(params);
                  if(_res.data != 'fail'){
                    if(_res.data.data[0].logo_url){
                      i.logo_url = _res.data.data[0].logo_url;
                    }else{
                      i.logo_url = questioner_logo;
                    }
                  }
                  // api.getCustomerInfoByNum(params).then((res)=>{
                  //   console.log(res);
                  //   if(res.data != 'fail'){
                  //     if(res.data.data[0].logo_url){
                  //       i.logo_url = res.data.data[0].logo_url;
                  //     }else{
                  //       i.logo_url = questioner_logo;
                  //     }
                  //   }

                  // },(err)=>{
                  //   console.log(err);
                  // })

                }catch(err){
                  console.log(err);
                }

              }
            }
              if(res.data.data.username!=""){
                if(i.user == "user" && i.flag =='right'){
                  i.username = res.data.data.username;
                }
              }

              if(i.user == "system" && i.flag =='left'){
                i.username =  state.html_const.cons_266_moppy_name;//もっぴー
              }
          }
        }
        state.manualChatbotShowFlg = false;
        state.piChatbotVisible = false;
        state.piIssuesVisible = false;
        console.log(allText);
        // del br
        if (allText.length > 0) {
          for(let i of allText){
            if(res.data.data.username!=""){
              if(i.user == "user" && i.flag =='right'){
                i.user = res.data.data.username
              }
            }
            if(i.user == "system" && i.flag =='left'){
              i.user =  state.html_const.cons_266_moppy_name;//もっぴー
            }
            let temp = i.text;
            let newText = "";
            i.text = temp.replace("<br>","");
            if(i.text.indexOf("<br>") != -1){
              let arr = i.text.split("<br>");
              arr.pop();
              newText = arr.join("<br>")
              i.text = newText.replace("<br><br>","<br>");
            }
          }
        }
        console.log(allText);




      }else{
        state.manualChatbotShowFlg = true;

      }
      //update manualChatbotAllTextList
      Vue.set(state.manualChatbotAllTextList,0,state.manualChatbotAllTextList[0]);
    }), (err) => {
      console.log(err);
    };
  },

  changeQueryNote(context, query_note) {
    context.commit('changeQueryNote', query_note);
  },

  logout(context, item) {
    const user_id = sessionStorage.getItem("user_id");
    const app_link = sessionStorage.getItem("app_link");
    let params = {
          user_id:user_id,
          app_link:app_link
        }
    api.logout(params).then((res) => {
      sessionStorage.clear()
      const logoutUrl = res.data.logoutUrl; 
      window.location.href = logoutUrl;
    }, (err) => {
      console.log(err);
    });
  },
  getSttToken(context, item) {
    // console.log('state.ws_mode', state.ws_mode)
    return new Promise((resolve, reject) => {
      api.getSttToken(state.ws_mode).then((res) => {
        state.sttConfig = {
          subscriptionKey: res.data.data.subscriptionKey,
          region: res.data.data.region,
          language: res.data.data.language,
          customization_id: res.data.data.customization_id,
          endpointId: res.data.data.endpointId,
          env_name: res.data.data.env_name,
          expiration: res.data.data.expiration,
          accessToken: res.data.data.token, // Authorization token to use this service, configured from /speech/stt-token.js file
          expires_in: res.data.data.expires_in,
          expiration: res.data.data.expiration,
          continuous: true, // False = automatically stop transcription the first time a pause is detected
          inactivityTimeout: -1,
          //model: 'ja-JP_BroadbandModel',
          model: res.data.data.language_model,
          resultsBySpeaker: true,
          left: true,
          languageCustomizationId: res.data.data.customization_id,
          timestamps:true,
          interimResults:true,
          lowLatency:true,
        };

        state.chatSttConfig = {
          accessToken: res.data.data.token,  // Authorization sttToken to use this service, configured from /speech/stt-sttToken.js file
          expires_in: res.data.data.expires_in,
          expiration: res.data.data.expiration,
          continuous: true, // False = automatically stop transcription the first time a pause is detected
          // outputElement: document.getElementById('autoInput'), // CSS selector or DOM Element
          inactivityTimeout: -1, // Number of seconds to wait before closing input stream
          format: true, // Inhibits errors
          keepMicrophone: false, // Avoids repeated permissions prompts in FireFox
          model: res.data.data.language_model,
          // language_customization_id: sttCustomizationId,
          url: res.data.data.url,
          languageCustomizationId: res.data.data.customization_id,
          timestamps:true,
          interimResults:true,
          lowLatency:true,
        };
        console.log('sttconfig', state.sttConfig)
        resolve()
      });
    })
  },

  searchByCondition(context, item){
   let  params = item.params;

    api.searchByCondition(params).then((res)=>{
      console.log(res)
      if(res.data.data != "fail"){
        state.searchConsequence = res.data.data;
        for(let i of state.searchConsequence){
          i["searchIsChecked"] = false;
        }

        state.isSearchLoading = false;
      }
    }),(err)=>{
      console.log(err)
    }

  },

  addNewUser(context, item){
    let  params = item.params;
    api.addNewUser(params).then((res)=>{
      console.log(res);
      if(res.data != 'fail'){
        Message.success({message: state.html_const.cons_271_add_new_customer_success});
      }else{
        Message.warning("error")
      }
    }),(err)=>{
      console.log(err)
    }
  },

  changeCustomerInfoConfirm(context, item){

    let params = {
      'phone_number':item.params
    };

    api.changeCustomerInfoConfirm(params).then((res)=>{
      console.log(res)

    }),(err)=>{
      console.log(err)
    }
  },
  getUnsolvedIssueListByPhone(context, val) {

    // 未解決チケット検索中、ローディング開始
    state.searchDetail_unsolvedIssueListVisible = true;

    // 問い合わせ者のlogoを設定する
    let loginUrl = "";
    let temp = _.find(state.customerList, function (o) {
      return o.phonenum == val.phoneNum;
    });
    if (temp) {
      if (temp.logo_url) {
        loginUrl = temp.logo_url;
      } else {
        loginUrl = questioner_logo;
      }
    }
    state.userInfoForUnsolvedIssues = {phoneNum: val.phoneNum, logoUrl: loginUrl};

    // 未解決チケットを取得する
    state.unsolvedIssueList = [];
    api.searchUnsolvedIssues({ phoneNum: val.phoneNum, currentIssueId: val.currentIssueId}).then(
      (res) => {
        // 未解決チケットリストを設定する
        state.unsolvedIssueList = res.data.data && res.data.data.issue_list ? res.data.data.issue_list :[] ;
        // ローディング終了
        state.searchDetail_unsolvedIssueListVisible = false;
        // 
        if(state.unsolvedIssueList.length>0){
          context.dispatch('setLatestUnsolvedIssue', state.unsolvedIssueList[0]);
        }
      },
      (err) => {
        console.log(err);
      }
    );
  },
  setLatestUnsolvedIssue(context, item){
    console.log('setLatestUnsolvedIssue',item)
    function setSearchDetailIssueSystemVar(item){
      if (item.tracker_name == 'AI ASSISTANT' || item.tracker_name == 'OPERATOR CHAT'){
        state.searchDetail_issue_system_logo = item.assigned_to_logo_url
        state.searchDetail_issue_system_name = vueUtils.computeFullName(item.assigned_to_lastname, item.assigned_to_firstname)
        state.searchDetail_issue_system_num =  item.assigned_to_tel_num ?  item.assigned_to_tel_num : ''

      }else if(item.tracker_name == 'AI CHATBOT'){
        state.searchDetail_issue_system_logo = watson_logo 
        state.searchDetail_issue_system_name =  'AI CHATBOT'
      }else{
        state.searchDetail_issue_system_logo = voicebot_logo
        state.searchDetail_issue_system_name =  'AI VOICEBOT'
      }

    }
    setSearchDetailIssueSystemVar(item)
    state.searchDetail_issue_category = item.category_name ? item.category_name:'';
    state.searchDetail_issue_tracker = item.tracker_name;
    state.searchDetail_issue_channel = item.channel ? item.channel :''
    state.manualChatbotAllTextList = utils.splitAllText(item.all_text,item.tracker_name,state.searchDetail_issue_system_logo,state.userInfoForUnsolvedIssues.logoUrl);
    state.manualChatbotCategoryTag = item.category_tag_list;
  }





//   getCustomerInfoByNum(context, item){
//     let params = {
//       phonenum:item.phonenum
//     }
//     api.getCustomerInfoByNum(params).then((res)=>{
//       console.log(res);
//       if(res.data != 'fail'){
//         state.temp_chat_waiting_questioner = res.data.data[0];
//       }

//     },(err)=>{
//       console.log(err);
//     })

// }



}
const mutations = {

  // getUC1IssueAllText(context, item) {

  //   let val = item;
  //       let params = {
  //         userId: state.manualChatQuestionerId
  //       };
  //       api.getUC1IssueAllText(params).then((res) => {
  //         // state.uc1AllTextList = res.data;
  //         let allText = res.data.data;
  //         console.log(allText);
  //         if( allText.length>0){
  //           for(let i of  allText){
  //             if(i.flag == "right"){
  //               let data = {
  //                 id: state.messageId++,
  //                 flag: "right",
  //                 userId: state.manualChatQuestionerId,
  //                 text: i.text,
  //                 checked: false,
  //                 user: i.user,
  //                 messageTime: i.messageTime
  //               }
  //               state.manualChatMessageList.push(data);
  //             };
  //             if(i.flag == "left"){
  //               let data = {
  //                 id: state.messageId++,
  //                 flag: "left",
  //                 userId: state.manualChatQuestionerId,
  //                 text: i.text,
  //                 checked: false,
  //                 user: i.user,
  //                 messageTime: i.messageTime
  //               }
  //               state.manualChatMessageList.push(data);
  //             }
  //           }
  //         }
  //         console.log(val);
  //         // console.log(Object.values(val)[0].id)
  //         // console.log(val.id);
  //         // console.log(val["id"]);
  //         let tempList =  Object.values(val)[0].notReadList;
  //         console.log(tempList)
  //         for (let i = 0; i <tempList.length; i++) {
  //           let data = {
  //             id: state.messageId++,
  //             flag: "right",
  //             userId: Object.values(val)[0].id.id,
  //             text: tempList[i].message,
  //             checked: false,
  //             user: state.html_const.cons_217_questioner,
  //             messageTime: moment().tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm:ss"),
  //           };
  //           state.manualChatMessageList.push(data);

  //           context.dispatch(
  //             "redmine/manualChatMessageRecord",
  //             {},
  //             { root: true }
  //           );

  //           let item = {
  //             flag: data.flag,
  //             text: data.text,
  //             mode: state.ws_mode,
  //           };

  //           context.dispatch("stt/fetchKeywordByDialog", {
  //             ...item,
  //             request_id: redmine.state.issue_id,
  //             keywordRate: state.keywordRate,
  //           });
  //         }

  //       }), (err) => {
  //         console.log(err);
  //       }
  //     },



  changeSingleMode(state, defaultSingleMode) {
    state.defaultSingleMode = defaultSingleMode;
    // console.log('state.defaultSingleMode', defaultSingleMode)
  },
  changeSysConfig(state, sysConfig) {
    // console.log('sysConfig', sysConfig)
    if (sysConfig.hasOwnProperty('showImmediately')) {
      state.showImmediately = sysConfig.showImmediately;
    }
    if (sysConfig.hasOwnProperty('keywordRate')) {
      state.keywordRate = sysConfig.keywordRate;
    }
    if (sysConfig.hasOwnProperty('personalSingleMode')) {
      state.personalSingleMode = sysConfig.data.personalSingleMode;
    }
    if (sysConfig.hasOwnProperty('noiseCancelBk')) {
      state.noiseCancelBk = parseInt(sysConfig.data.noiseCancelBk);
      Bus.$emit("noiseCancelBk", state.noiseCancelBk);
    }
    if (sysConfig.hasOwnProperty('noiseCancelSpeech')) {
      state.noiseCancelSpeech = parseInt(sysConfig.data.noiseCancelSpeech);
      Bus.$emit("noiseCancelSpeech", state.noiseCancelSpeech);
    }
    if (sysConfig.hasOwnProperty('systemSingleMode')) {
      state.systemSingleMode = sysConfig.systemSingleMode;
    }
    if (sysConfig.hasOwnProperty('personalEnable')) {
      state.personalEnable = sysConfig.personalEnable;
    }
    if (sysConfig.hasOwnProperty('modeFlag')) {
      state.modeFlag = sysConfig.modeFlag;
    }
    if (sysConfig.hasOwnProperty('role')) {
      state.user_role = sysConfig.role;
    }
    // if(sysConfig.hasOwnProperty('user_id')){
    //   state.user_id = sysConfig.user_id;
    // }

    // console.log('state.personalSingleMode', state.personalSingleMode)
    // console.log('state.showImmediately', state.showImmediately);


  },
  changeSipConfig(state,sipConfig){
    console.log('sipConfig.....', sipConfig)
    if (sipConfig.hasOwnProperty('sip_domain')) {
      state.sip_domain = sipConfig.sip_domain;
    }
    if (sipConfig.hasOwnProperty('sip_wss_server')) {
      state.sip_wss_server = sipConfig.sip_wss_server;
    }
    if (sipConfig.hasOwnProperty('sip_server_path')) {
      state.sip_server_path = sipConfig.sip_server_path;
    }
    if (sipConfig.hasOwnProperty('sip_pw')) {
      state.sip_pw = sipConfig.sip_pw;
    }
    if (sipConfig.hasOwnProperty('sip_websocket_port')) {
      state.sip_websocket_port = sipConfig.sip_websocket_port;
    }
    console.log('state.....', state)
  },
  changeQueryNote(state, query_note) {
    state.query_note = query_note;
  },
  changeNavigationText(context, navigationText) {
    state.ngWordColor = false;
    state.wowWordColor = false;
    state.warningWordColor = false;
    state.navigationText = navigationText;
  },
  changeNgColor(context, ngWordColor) {
    state.ngWordColor = true;
  },
  changeWowColor(context, wowWordColor) {
    state.wowWordColor = true;
  },
  changeWarningColor(context, warningWordColor) {
    state.warningWordColor = true;
  },
  changeCurrentKeyword(context, currentKeyword) {
    state.currentKeyword = currentKeyword;
  },
  changeKeywordRate(context, keywordRate) {
    state.keywordRate = keywordRate;
  },
  changeUserName(context, user_name) {
    state.user_name = user_name;
  },
  changeUserId(context, userId) {
    state.user_id = userId;
  },
  changeHtmlConst(context, html_const) {
    state.html_const = html_const;
    // console.log('state.html_const', state.html_const)
  },
  // 更新顾客列表
  changeAllCustomer(context, customerList) {
    state.customerList = customerList;
    // console.log('state.customerList', state.customerList)
  },
  // 更新用户列表
  changeUserList(context, userList) {
    state.userList = userList;
  },
  changeNexmoWebsocketUri(context, nexmo_websocket_uri) {
    state.nexmo_websocket_uri = nexmo_websocket_uri;
    // console.log('state.nexmo_websocket_uri', state.nexmo_websocket_uri)
  },
  changeUserTelNum(context, tel_num) {
    state.tel_num = tel_num;
  },
  // changeLogos(context, logos) {
  //   if (logos.questioner_logo) {
  //     state.questioner_logo = logos.questioner_logo
  //   }
  //   if (logos.operator_logo) {
  //     state.operator_logo = logos.operator_logo
  //   }
  //   if (logos.watson_logo) {
  //     state.watson_logo = logos.watson_logo
  //   }
  // },
  changeWSIssueId(context, issue_id) {
    redmine.state.issue_id = issue_id;
  },

  changeTalkStatus(context, talkStatus) {
    state.talkStatus = talkStatus;
  },
  changeDraggableFlag(context, draggableFlag) {
    state.draggableFlag = draggableFlag;
    // console.log("draggableFlag", draggableFlag)
  },
  changePhoneNum(context, phonenum) {
    state.phonenum = phonenum;
  },

  changeManualChatIssueId(context, issueId) {
    // state.manualChatModeIssueId = issueId
    redmine.state.issue_id = issueId;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
  mode
}

